<template>
  <div id="returnOrderInfo" class="return-print-list_box">
    <el-form
      :inline="false"
      label-width="0px"
      :model="data"
      :rules="rules"
      ref="ruleForm"
      v-loading="saveLoading"
    >
      <!-- 发件人信息 -->
      <div class="reutrn-box y-mt-10">
        <div class="trangle"></div>
        <div class="y-f y-f-a">
            <div class="y-f y-f-a y-f-fc icon-box">
              <svg-icon icon-class="icon_Send " class="icon-send-style"></svg-icon>
              <span class="y-fc-systemcolor">寄件地址</span>
            </div>
            
            <div class="y-mt-10">
              <div class="y-f y-f-a">
                <span class="recive-select-btn">
                  <span @click="changeSenderModel('X')" class="radio-btn y-mr-4" :class="{'active-radio-btn': senderModel=='X'}">选择</span>
                  <span @click="changeSenderModel('T')" class="radio-btn" :class="{'active-radio-btn': senderModel=='T'}">填写</span>
                </span>
              </div>
              <div>
                <div v-if="senderModel == 'X'">
                  <div class="y-f y-mt-8  y-f-a y-mb-0">
                    <el-form-item label="" style="margin-bottom: 0" label-width="">
                      <el-select
                        :popper-append-to-body="false"
                        popper-class="y-w-600"
                        class="y-w-600 remote-style"
                        v-model="addressId"
                        filterable
                        remote
                        placeholder="请输入关键词"
                        :remote-method="remoteMethod"
                        @visible-change="initAddrInfo"
                        @change="getAddressList()"
                        :loading="addrLoading">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div class="y-f y-f-a y-mt-8 y-f-js y-mb-0" v-else>
                  <div class="y-f" >
                    <div class="">
                      <div class="y-f y-f-jb">
                        <el-form-item label="" prop="sendName">
                          <el-autocomplete
                            class="y-w-180"
                            popper-class="print-list_w500"
                            v-model.trim="data.sendName"
                            :fetch-suggestions="querySearchAsync"
                            :debounce="0"
                            @select="handleSelectSender"
                            placeholder="请输入发件人姓名"
                          ></el-autocomplete>
                          <!-- <el-input
                            class="y-w-180"
                            popper-class="print-list_w500"
                            v-model.trim="data.sendName"
                            placeholder="请输入发件人姓名"
                          ></el-input> -->
                        </el-form-item>
                        <el-form-item
                          ref="sendMobile"
                          label=""
                          prop="sendMobile"
                          label-width="0"
                        >
                          <el-input
                            class="y-w-180"
                            v-model="data.sendMobile"
                            :maxlength="11"
                            placeholder="请输入手机号码"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          ref="sendPhone"
                          label=""
                          prop="sendPhone"
                          label-width="0"
                        >
                          <el-input
                            class="y-w-180"
                            v-model="data.sendPhone"
                            :maxlength="20"
                            placeholder="请输入电话号码"
                          ></el-input>
                        </el-form-item>
                      </div>
                      <div>
                        <el-form-item label="" prop="districtSend">
                          <regionSelector
                            ref="areaListSend"
                            id="sendArea"
                            :isDisable="isSendHy"
                            :areaList="areaListSend"
                            @changeRegion="changeRegionSend"
                            fromPage="printList"
                          ></regionSelector>
                        </el-form-item>
                      </div>
                      <div class="y-f y-f-a y-f-jb big-screen">
                        <el-form-item label="" prop="sendAddress" class="y-mb-0">
                          <el-input
                            class="y-w-500"
                            v-model="data.sendAddress"
                            :maxlength="255"
                            placeholder="请输入详细地址(街道、社区、门牌号等)"
                          ></el-input>
                        </el-form-item>
                        <el-checkbox class="clear-text" v-model="data.checkedSender" :disabled="sourceOperation == 2">保存到地址簿</el-checkbox>
                        <span class="clear-text systemColor" @click="clearSenderInfo">清空内容</span>
                      </div>
                    </div>
                    <div class="y-b-s y-h-120">
                      <div class="anlysize-style y-b-s">
                        <el-input
                          type="textarea"
                          resize="none"
                          :rows="4"
                          :maxlength="200"
                          placeholder="觉得填写麻烦？粘贴发件人信息到此处，点击一键解析，系统将自动填写。如 张三 18223459856 陕西省西安市雁塔区锦业路中心大厦"
                          v-model="totalInfoSend"
                          @blur.stop="blurAddr('send')">
                        </el-input>
                        <div class="y-f y-f-je y-f-a">
                          <!-- 上传图片 -->
                          <el-upload
                            class="identify-avatar-uploader"
                            action
                            accept=".jpg,.jpeg,.png"
                            :show-file-list="false"
                            :before-upload="beforeAvatarUploadSend">
                            <div class="systemColor align-right systemSize">图片识别</div>
                          </el-upload>
                          <div class="systemColor align-right systemSize" @click.stop="smartResolve('send')">一键解析</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="sendUploadedImage" class="address-uploaded">
                      <i class="el-icon-error viewClose y-c-p" @click="sendUploadedImage = ''"></i>
                      <img :src="sendUploadedImage"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <!-- 收件人信息 -->
      <div class="reutrn-box">
        <div class="trangle"></div>
        <div class="y-f y-f-a">
          <div class="y-f y-f-a y-f-fc icon-box">
            <svg-icon icon-class="icon_Receive" class="icon-send-style"></svg-icon>
            <span class="y-fc-systemcolor">收件地址</span>
          </div>
          <div class="y-mt-10">              
            <div class="y-f y-f-jb">
              <el-form-item label="" prop="receiveName">
                <el-autocomplete
                  v-model.trim="data.receiveName"
                  class="y-w-180"
                  popper-class="print-list_w500"
                  :debounce="0"
                  :fetch-suggestions="querySearchAsyncRecive"
                  @select="handleSelectRevice"
                  placeholder="请输入收件人姓名"
                  :disabled="sourceOperation == 2"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item
                ref="receiveMobile"
                label=""
                prop="receiveMobile"
                label-width="0"
              >
                <el-input
                  v-model="data.receiveMobile"
                  class="y-w-180"
                  :maxlength="11"
                  placeholder="请输入手机号码"
                  :disabled="sourceOperation == 2"
                ></el-input>
              </el-form-item>
              <el-form-item
                ref="receivePhone"
                label=""
                prop="receivePhone"
                label-width="0"
              >
                <el-input
                  class="y-w-180"
                  v-model="data.receivePhone"
                  :maxlength="20"
                  placeholder="请输入电话号码"
                  :disabled="sourceOperation == 2"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="" prop="district">
                <regionSelector
                  ref="areaList"
                  id="Area"
                  :isDisable="isReciveHy"
                  :areaList="areaList"
                  @changeRegion="changeRegion"
                  :sourceOperation="sourceOperation+''"
                  fromPage="printList"
                ></regionSelector>
              </el-form-item>
            </div>
            <div class="y-f y-f-a y-f-jb big-screen">
              <el-form-item label="" prop="receiveAddress" class="y-mb-0">
                <el-input
                  class="y-w-400"
                  v-model="data.receiveAddress"
                  :maxlength="255"
                  placeholder="请输入详细地址(街道、社区、门牌号等)"
                  :disabled="sourceOperation == 2"
                ></el-input>
              </el-form-item>
              <span class="clear-text systemColor" @click="clearReciverInfo" v-if="sourceOperation != 2">清空内容</span>
            </div>
          </div>
          <div class=" y-b-s y-h-120">
            <div class="anlysize-style y-b-s">
              <el-input
                type="textarea"
                resize="none"
                :rows="4"
                :maxlength="200"
                placeholder="觉得填写麻烦？粘贴收件人信息到此处，点击一键解析，系统将自动填写。如 张三 18223459856 陕西省西安市雁塔区锦业路中心大厦"
                v-model="totalInfo"
                :disabled="sourceOperation == 2"
                @blur.stop="blurAddr('receive')"
              >
              </el-input>
              <div class="y-f y-f-je y-f-a">
                <!-- 上传图片 -->
                <el-upload
                  class="identify-avatar-uploader"
                  action
                  accept=".jpg,.jpeg,.png"
                  :disabled="sourceOperation == 2"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUploadRecive">
                  <div class="y-fc-999 align-right systemSize" :class="{'systemColor': sourceOperation != 2}">图片识别</div>
                </el-upload>
                <div class="systemColor align-right systemSize" @click.stop="smartResolve('receive')">一键解析</div>
              </div>
            </div>
          </div>
          <div v-if="reciveUploadedImage" class="address-uploaded">
            <i class="el-icon-error viewClose y-c-p" @click="reciveUploadedImage = ''"></i>
            <img :src="reciveUploadedImage"/>
          </div>
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="reutrn-box">
        <div class="trangle"></div>
        <div class="y-f y-f-a y-mt-10">
          <div class="y-f y-f-a icon-box-small">
            <svg-icon icon-class="icon_Time" class="icon-style"></svg-icon>
            <span class="y-fc-systemcolor">取件时间</span>
          </div>
          <div class="y-f y-f-a">
            <span class="recive-select-btn y-mr-16">
              <span @click="chageTimedPickupFn('1')" class="radio-btn y-mr-4" :class="{'active-radio-btn': data.timedPickup == 1}">当日取</span>
              <span @click="chageTimedPickupFn('2')" class="radio-btn" :class="{'active-radio-btn': data.timedPickup == 2}">定时取</span>
            </span>
            <div class="y-f y-f-a">
              <el-form-item label="" label-width="0" prop="reciveTime" class="y-mb-0" v-if="data.timedPickup == 1">
                <selectTime
                  ref="reciveTimeComponent"
                  v-if="isRefreshTime"
                  :receiveAddressInfo="receiveAddressInfo"
                  typeFlag="1"
                  fromPage="createOrder"
                  @selectedTime="selectedReciveTimeFn"
                  @setTimeType="chageTimedPickupFn"
                ></selectTime>
              </el-form-item>
              <el-form-item label="" label-width="0" prop="selectedTime" class="y-mb-0" v-if="data.timedPickup == 2">
                <selectTime
                ref="selectedTimeComponent"
                  v-if="isRefreshTime"
                  :receiveAddressInfo="receiveAddressInfo"
                  typeFlag="2"
                  fromPage="createOrder"
                  @selectedTime="selectedTimeFn"
                  @setTimeType="chageTimedPickupFn"
                ></selectTime>
              </el-form-item>
            </div>          
          </div>
        </div>
      </div>
      <div class="reutrn-box">
        <div class="trangle"></div>
        <div class="y-f y-f-a y-mt-10">
          <div class="y-f y-f-a icon-box-small">
            <svg-icon icon-class="icon_File" class="icon-style"></svg-icon>
            <span class="y-fc-systemcolor">商品信息</span>
          </div>
          <div class="">
            <div class="y-f y-f-js" v-for="(good, gidx) in data.orderProducts" :key="'good_'+gidx">
              <div class="y-f ">
                <div>
                  <div class="y-mb-6">
                    <span>商品名称</span>
                    <span class="y-fc-4C84FF y-c-p y-ml-8" @click="selectedGoodsOptions">设置</span>
                  </div>
                  <el-form-item
                    class="form-item-wrap-f" label="" label-width="0"
                    :prop="'orderProducts.' + gidx + '.goodName'"
                    :rules="{ required: true, message: '商品名称不能为空', trigger: ['blur', 'change'] }">
                    <el-autocomplete
                      clearable
                      popper-class="print-list_w500"
                      class="y-f-l y-f-1 y-w-500"
                      v-model="good.goodName"
                      :fetch-suggestions="querySearchAsyncProduct"
                      :debounce="0"
                      :ref="`el_auto_${gidx}`"
                      @clear="clearSelect(gidx)"
                      :maxlength="100"
                      placeholder="请输入商品名称"
                      @change="(val, gidx) => validName(val, gidx)"
                    ></el-autocomplete>
                  </el-form-item>
                </div>
                <div class="y-ml-28">
                  <div class="y-mb-6">
                    <span>商品数量</span>
                  </div>
                  <el-form-item class="form-item-wrap-f" label="" label-width="">
                    <el-input-number
                    class="y-w-180"
                    :disabled="sourceOperation == 2"
                    v-model="good.goodNum"
                    :min="1"
                    :max="99999"
                    :precision="0"
                    :step="1"
                    ></el-input-number>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item class="form-item-wrap-f imgUrl y-mt-10" label="" label-width="" v-if="good.goodUrl">
                    <i class="el-icon-error close-btn" @click="removeImgUrl(gidx)" ></i>
                    <el-image
                      style="width: 48px; height: 48px"
                      :src="good.goodUrl" 
                      :preview-src-list="[good.goodUrl]">
                    </el-image>
                  </el-form-item>
                </div> 
                <div>
                  <div class="y-mb-6">
                    <span>&nbsp;</span>
                  </div>
                  <el-button class="y-ml-25 addBtn" type="primary" v-if="gidx==0" @click="addProdcutInfoFn" icon="el-icon-plus">添 加</el-button>
                  <el-button class="normal-btn addBtn y-ml-25" type="buttom" v-if="gidx>0" @click="delProdcutInfoFn(gidx)" icon="el-icon-delete">删 除</el-button>
                </div>               
              </div>              
            </div>
          </div>
        </div>
      </div>
      <div class="reutrn-box">
        <div class="trangle"></div>
        <div class="y-f y-f-a y-mt-10">
          <div class="y-f y-f-a icon-box-small">
            <svg-icon icon-class="icon_Other" class="icon-style"></svg-icon>
            <span class="y-fc-systemcolor">其他信息</span>
          </div>
          <div class="">
            <div class="y-mb-6">预计包裹重量(kg)</div>
            <el-form-item label="" label-width="0" prop="goodsWeight" class="y-mb-0">
              <el-input-number
                class="y-w-180"
                :disabled="sourceOperation == 2"
                v-model="data.goodsWeight"
                :min="0.01"
                :max="50"
                :precision="2"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <div class="y-mb-6 y-mt-10">备注</div>
            <el-form-item label="" label-width="0" prop="mallRemark" class="y-mb-0">
              <el-autocomplete
                clearable
                id="remark-id"
                v-model="data.mallRemark"
                class="y-w-500"
                popper-class="print-list_w500"
                :debounce="0"
                :fetch-suggestions="querySearchAsyncRemark"
                @select="handleSelectRemark"
                :maxlength="200"
                placeholder="请输入备注"
              >
              </el-autocomplete>
            </el-form-item>
          </div>
        </div>
      </div>
      <!-- <div class="reutrn-box">
        <div class="trangle"></div>
        <div class="y-f y-f-a y-mt-10">
          <div class="y-f y-f-a icon-box-small">
            <svg-icon icon-class="icon_brokerage" class="icon-style"></svg-icon>
            <span class="y-fc-systemcolor">付费方式</span>
          </div>
          <div class="y-f ">
            <el-form-item label="" label-width="0" prop="isCheckedMerchanPay" class="y-mb-0">
              <div class="y-f y-f-a y-mr-20">
                <span @click="checkedMerchanPaytFn" class="y-c-p y-f y-f-a">
                  <img src="@/assets/images/icon/icon_checbox_checked.png" class="check-icon" v-if="data.isCheckedMerchanPay" />
                  <img src="@/assets/images/icon/icon_checbox.png" class="check-icon" v-else  />
                  <span>商家付运费</span>
                </span>
              </div>
            </el-form-item>
            <el-form-item label="" label-width="0" prop="brokerage" class="y-mb-0">
              <div class="y-f y-f-a">
                <span @click="checkedBrokerageFn" class="y-c-p y-f y-f-a">
                  <img src="@/assets/images/icon/icon_checbox_checked.png" class="check-icon" v-if="data.isCheckedBrokerage" />
                  <img src="@/assets/images/icon/icon_checbox.png" class="check-icon" v-else  />
                  <span>加价寄件人付费返佣</span>
                </span>
                <span v-if="!!data.isCheckedBrokerage&&isAliNameFlag" class="y-ml-10">
                  <span>每单加价</span>
                  <el-input-number v-model="data.brokerage" :min="0.5" :max="2" :step="0.5" class="y-ml-5 y-mr-5 y-w-180" :step-strictly="true"></el-input-number>
                  <span>元作为佣金</span>
                </span>
                <span class="y-c-p y-ml-10 y-fc-systemcolor y-mr-20" @click="openBrokerageFn('1')">查看详情</span>
              </div>
            </el-form-item>
            <el-form-item label="" label-width="0" prop="payType" class="y-mb-0">
               <div class="y-f y-f-a">
                <span @click="checkedPayTypeFn" class="y-c-p y-f y-f-a">
                  <img src="@/assets/images/icon/icon_checbox_checked.png" class="check-icon" v-if="data.isCheckedPayType"   />
                  <img src="@/assets/images/icon/icon_checbox.png" class="check-icon" v-else  />
                  <span>不加价寄件人付费</span>
                </span>
                <span v-if="!!data.isCheckedPayType" class="y-ml-10">
                  <span>寄件人付</span>
                  <el-select v-model="data.payType" placeholder="请选择" class="y-ml-5 y-mr-5  y-w-180">
                    <el-option
                      v-for="item in buyerPaysOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </span>
                <span class="y-c-p y-ml-10 y-fc-systemcolor" @click="openBrokerageFn('2')">查看详情</span>
              </div>
            </el-form-item>
          </div>
        </div>
      </div> -->
      <div class="fixed-box p40" :class="{'bottom--m-m':(data.isCheckedBrokerage||data.isCheckedPayType)}">
        <div class="y-f y-f-a y-f-jc" :class="{ 'mt-34': !rewardCardBanlance}">
          <div class="y-f y-f-fc" :class="{'y-pb-20': rewardCardBanlance&&!data.isCheckedBrokerage&&!data.isCheckedPayType}">
            <!-- <div class="top-box y-f y-f-a y-mt-8" v-if="rewardCardBanlance&&!data.isCheckedBrokerage&&!data.isCheckedPayType">
              <img src="@/assets/images/icon/pic_HB@2x.png" class="reward-icon" />
              <div class="y-f y-f-a reward-tip">
                <span class="y-pl-20 ">您有一张余额</span>
                <span class="y-fs-16 y-mr-5 y-ml-5">{{rewardCardBanlance}}</span>
                <span>元的体验优惠券，本次下单将为您自动抵扣运费</span>
              </div>
            </div> -->
            <div class="y-f y-f-ab y-fs-14" :class="{'pl44': rewardCardBanlance}">
              <span>本单预计运费：</span>
              <!-- 绑定了营销业务员或网点，且预估运费余额大于优惠金额，才显示优惠金额 -->
              <!-- <template v-if="!data.isCheckedBrokerage&&!data.isCheckedPayType&&activeFlag&&isBindUserInfo && estimatedFreight > activityInfo.orderPrice">
                <span class="systemColor y-fs-22 y-mr-5 y-f-b">{{estimatedFreightNew}}</span><span class="delLine">{{estimatedFreight}}</span>元
              </template> -->
              <template>
                <span class="systemColor y-fs-22 y-mr-5 y-f-b">{{estimatedFreight}}</span>元
              </template>
              <!-- 绑定了营销业务员或网点，显示优惠活动信息 -->
              <!-- <template v-if="isBindUserInfo&&activeFlag&&!data.isCheckedBrokerage&&!data.isCheckedPayType">
                <span class="y-ml-10">已优惠：</span><span class="y-fs-24 y-mr-5 y-f-b">{{activityInfo.orderPrice || 0}}</span>元
                <el-popover placement="top-start" width="200" popper-class="activity-nyp-creatOrderInfo" trigger="hover">
                  <div class="prover-content">
                    <div class="prover-title">优惠详情</div>
                    <div class="prover-main">
                      <div>营销活动减免 {{activityInfo.orderPrice || 0}}元</div>
                    </div>
                  </div>
                  <i class="el-icon-question y-ml-5 y-c-p" slot="reference"></i>
                </el-popover>
              </template> -->
              <span class="y-ml-10">当前运费余额：</span><span class="y-fs-24 y-mr-5 y-f-b">{{balance}}</span>元
            </div>
          </div>
          <div class="y-f y-f-a y-f-je y-ml-80">
            <el-button type="primary" @click="finishGoOn()" class="bottom--m-m"><img class="order-icon" src="@/assets/images/icon/icon_Click@2x.png" />确认下单</el-button>
            <el-button type="primary" @click="finishGoOn('print')" class="bottom--m-m">下单并打印</el-button>
            <el-checkbox v-model="isShowPrivacy" v-if="!isCheckedPrivacy" class="y-ml-16">我已阅读并同意</el-checkbox>
            <span class="systemColor y-c-p" @click="showPrivacyDialog = true;" v-if="!isCheckedPrivacy">《功能使用协议》</span>
          </div>
        </div>
      </div>
    </el-form>
    <!-- 添加商品选项 -->
    <addGoodsOptions
      v-if="addOptionsDialogVisble"
      :isShow="addOptionsDialogVisble"
      @closeGoodsOptions="closeGoodsOptions"
    ></addGoodsOptions>
    <!-- 图片识别组件 -->
    <indentityPic
      v-if="isShowIndentifyPicDialog"
      :value="isShowIndentifyPicDialog"
      :identifyType="identifyInfoType"
      :imgUrl="imgUrl"
      @close="closeIdentifyInfo"
      @analysisPic="analysisPic"
    ></indentityPic>
    <!-- 下单协议 -->
    <privacy
      v-if="showPrivacyDialog"
      :isShow="showPrivacyDialog"
      :isCheckedPrivacy="isShowPrivacy"
      @close="closePrivacyDialog"
    ></privacy>
    <buyerPaysShippingDialog
      v-if="buyerPaysShippingDialogFlag"
      :isShow="buyerPaysShippingDialogFlag"
      @closeDialog="closeBuyerPaysShipping"
      :alipayName="alipayName"
      @changeBrokerage="changeBrokerage"
      @openSaveAccount="openSaveAccount"
      @goToRealName="goToRealName"
      ref="buyerPaysShippingDialog"
    ></buyerPaysShippingDialog>  

  </div>
</template>

<script>
import district from '@/mixins/district';
import addGoodsOptions from '../../customPrintNewReconsitution/components/addGoodsOptions';
import regionSelector from '@/components/regionSelector/indexCustomCascader';
import util, { isMobileNumber } from '@/utils/util';
import { getCustomerAddressApi } from '@/api/universal';
import { getDistrictPathUpApi } from '@/api/common';
import indentityPic from '../../customPrintNewReconsitution/components/identifyPictures';
import {validProductName} from '@/api/waybillPrint/customPrint';
import selectTime from './selectTime';
import privacy from './privacy';
import buyerPaysShippingDialog from './buyerPaysShippingDialog.vue';
import _ from "lodash"
import { addAddressApi } from '@/api/baseInfo/printSetting/addressMaintenance';
import { addCustomRemarkApi, addressResolutionApi, deleteCustomRemarkApi, getCustomRemarkListApi, queryGoodsOptionsListApi } from '@/api/waybillPrint/customPrint';
import { queryAccountInfoApi, getOrderInfoFromPlatformApi, createOrderForRetrunPickupApi, getEstimatedFreightForRetrunPickupApi, decryptUserInfoApi, queryListByTypeApi, insertConfirmRecordApi, queryRewardCordApi, searchAlipayBindApi, searchActivityApi} from '@/api/waybillPrint/returnPickupPrint'
import { createSpecialOrderApi } from '@/api/waybillPrint/sepecialOrderPrint'
export default {
  name: 'AddPrintOrderNew',
  components: {
    addGoodsOptions,
    regionSelector,
    indentityPic,
    selectTime,
    privacy,
    buyerPaysShippingDialog,
  },
  props: {
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    bindUserInfo: {
      type: Object,
      default: () => { 
        return {};
      }
    },
    bindSellerInfo: {
      type: Object,
      default: () => { 
        return {};
      }
    },
  },
  mixins: [district],
  computed: {
    userMess() {
      return this.$store.state.user;
    },
    isContainHyAddress() {
      if (this.data.fromProvinceName && this.data.fromProvinceName.indexOf('海外')>-1) {
        this.data.productType = 0;
        return true;
      }
      if (this.data.toProvinceName && this.data.toProvinceName.indexOf('海外')>-1) {
        this.data.productType = 0;
        return true;
      }
      return false;
    },
    receiveAddressInfo() {
      let receiverInfo = `${this.data.toProvinceName}|${this.data.toCityName}|${this.data.toDistrictName}`;
      return receiverInfo;
    },
    sendAndReciveAndWeight(){
      let senderInfo = `${this.data.fromProvinceCode}|${this.data.fromCityCode}|${this.data.fromDistrictCode}|${this.data.sendAddress}|${this.data.sendUnitAddress}`;
      let reciverInfo = `${this.data.toProvinceCode}|${this.data.toCityCode}|${this.data.toDistrictCode}|${this.data.receiveAddress}|${this.data.receiveUnitAddress}`;
      let weight = this.data.goodsWeight;
      let timedPickup = this.data.timedPickup;
      let timeSetp = timedPickup == 1 ? this.data.reciveTime : this.data.selectedTime;

      // 返回收、寄件人信息、重量
      return `${senderInfo}_${reciverInfo}_${weight}_${timedPickup}_${timeSetp}`;
    },
    isBindUserInfo() {
      return this.bindUserInfo.bindOrgCode || this.bindUserInfo.bindEmployeeCode;
    },
    estimatedFreightNew() {
      if (this.activityInfo.orderPrice > 0 && this.estimatedFreight > this.activityInfo.orderPrice) {
        let newNumber =  Number(this.estimatedFreight) - Number(this.activityInfo.orderPrice);
        return newNumber.toFixed(2);
      } else {
        return this.estimatedFreight;
      }
    },
    paymentType() {
      return `${this.data.isCheckedBrokerage ? 1 : 0}|${this.data.isCheckedPayType ? 1 : 0}`;
    }
  },
  watch: {
    sendAndReciveAndWeight(newVal, oldVal) {
      console.log(`收、寄件人信息、重量 ----${newVal}`)
      let addressInfo = newVal.split('_');
      if (addressInfo.length < 2) {
        return ;
      }

      let sendInfo = addressInfo[0].split('|');
      if (!(sendInfo.length > 2 && sendInfo[0] && sendInfo[1] && sendInfo[2])) {
        return;
      }

      let reciveInfo = addressInfo[1].split('|');
      if (!(reciveInfo.length > 2 && reciveInfo[0] && reciveInfo[1] && reciveInfo[2])) {
        return;
      }

      // 收发件人地址、与重量都有时，再调预估运费接口
      this.debouncedGetFreight();
    },
    receiveAddressInfo(newVal) {
      console.log(`寄件人信息----${newVal}`)

      let addressArr = newVal.split('|');
      if (!(addressArr.length > 2 && addressArr[0] && addressArr[1] && addressArr[2])) {
        return;
      }
      
      this.isRefreshTime = false;
      this.$nextTick(()=>{
        this.isRefreshTime = true;
      })
    },
    'data.isCheckedBrokerage': {
      handler(val) {
        // 确保至少选择一种支付方式
        if(!val && !this.data.isCheckedPayType && !this.data.isCheckedMerchanPay) {
          this.$set(this.data, 'isCheckedBrokerage', true);
        }
      },
      immediate: true
    },
    'data.isCheckedPayType': {
      handler(val) {
        // 确保至少选择一种支付方式
        if(!val && !this.data.isCheckedBrokerage && !this.data.isCheckedMerchanPay) {
          this.$set(this.data, 'isCheckedPayType', true);
        }
      },
      immediate: true
    },
    paymentType(val) {
      let arr = val.split('|') || [];
      if (arr[0] == '1' || arr[1] == '1' ) {
        this.$set(this.data, 'isCheckedMerchanPay', false);
      } else {
        this.$set(this.data, 'isCheckedMerchanPay', true);
      }
    }
  },
  data() {
    let valiMobile = (rule, value, callback) => {
      if (this.data.receiveMobile === '' && this.data.receivePhone === '') {
        return callback(new Error('手机号或电话至少填写一个！'));
      } else {
        if (
          !(/(^1\d{10}$)/.test(value) || /(^([5|6|9])\d{7}$)/.test(value)) &&
          value !== ''
        ) {
          return callback(new Error('手机号格式不正确'));
        } else {
          if (
            (value !== '' &&
              this.data.receivePhone !== '' &&
              !/^[\d-]+$/.test(this.data.receivePhone)) ||
            (value === '' && this.data.receivePhone !== '')
          ) {
            callback();
            this.$nextTick(() => {
              this.$refs['receiveMobile'].clearValidate();
            });
          } else {
            callback();
            this.$nextTick(() => {
              this.$refs['receiveMobile'].clearValidate();
              this.$refs['receivePhone'].clearValidate();
            });
          }
        }
      }
    };
    let valiPhone = (rule, value, callback) => {
      if (this.data.receiveMobile === '' && this.data.receivePhone === '') {
        return callback(new Error('手机号或电话至少填写一个！'));
      } else {
        // if (value !== '' && !/(^0\d{2,3}-\d{7,8}$)/.test(value)) {
        if (value !== '' && !/^[\d-]+$/.test(value)) {
          return callback(new Error('电话号码由数字和-组成！'));
        } else if (
          value !== '' &&
          /^[\d-]+$/.test(value) &&
          value.length > 20
        ) {
          return callback(new Error('电话号码长度不超过20个字符！'));
        } else {
          if (
            (value !== '' &&
              this.data.receiveMobile !== '' &&
              !(
                /(^1\d{10}$)/.test(this.data.receiveMobile) ||
                /(^([5|6|9])\d{7}$)/.test(this.data.receiveMobile)
              )) ||
            (value === '' && this.data.receiveMobile !== '')
          ) {
            callback();
            this.$nextTick(() => {
              this.$refs['receivePhone'].clearValidate();
            });
          } else {
            callback();
            this.$nextTick(() => {
              this.$refs['receiveMobile'].clearValidate();
              this.$refs['receivePhone'].clearValidate();
            });
          }
        }
      }
    };
    let valiMobileSend = (rule, value, callback) => {
      if (this.data.sendMobile === '' && this.data.sendPhone === '') {
        return callback(new Error('手机号或电话至少填写一个！'));
      } else {
        if (
          !(/(^1\d{10}$)/.test(value) || /(^([5|6|9])\d{7}$)/.test(value)) &&
          value !== ''
        ) {
          return callback(new Error('手机号格式不正确'));
        } else {
          if (
            (value !== '' &&
              this.data.sendPhone !== '' &&
              !/^[\d-]+$/.test(this.data.sendPhone)) ||
            (value === '' && this.data.sendPhone !== '')
          ) {
            callback();
            this.$nextTick(() => {
              this.$refs['sendMobile'].clearValidate();
            });
          } else {
            callback();
            this.$nextTick(() => {
              this.$refs['sendMobile'].clearValidate();
              this.$refs['sendPhone'].clearValidate();
            });
          }
        }
      }
    };
    let valiPhoneSend = (rule, value, callback) => {
      if (this.data.sendMobile === '' && this.data.sendPhone === '') {
        return callback(new Error('手机号或电话至少填写一个！'));
      } else {
        // if (value !== '' && !/(^0\d{2,3}-\d{7,8}$)/.test(value)) {
        if (value !== '' && !/^[\d-]+$/.test(value)) {
          return callback(new Error('电话号码由数字和-组成！'));
        } else if (
          value !== '' &&
          /^[\d-]+$/.test(value) &&
          value.length > 20
        ) {
          return callback(new Error('电话号码长度不超过20个字符！'));
        } else {
          if (
            (value !== '' &&
              this.data.sendMobile !== '' &&
              !(
                /(^1\d{10}$)/.test(this.data.sendMobile) ||
                /(^([5|6|9])\d{7}$)/.test(this.data.sendMobile)
              )) ||
            (value === '' && this.data.sendMobile !== '')
          ) {
            callback();
            this.$nextTick(() => {
              this.$refs['sendPhone'].clearValidate();
            });
          } else {
            callback();
            this.$nextTick(() => {
              this.$refs['sendMobile'].clearValidate();
              this.$refs['sendPhone'].clearValidate();
            });
          }
        }
      }
    };
    let addressStr = (rule, value, callback) => {
      value = value.replace(/(^\s*)|(\s*$)/g, "");
      if (!value) {
        callback(new Error('不能为空'));
      } else {
        callback();
      }
    };
    let specStrName = (rule, value, callback) => {
      if (value === '其他') {
        let prodcutName = this.prodcutName.trim();
        if (
          prodcutName !== '' &&
          prodcutName !== null &&
          prodcutName !== undefined
        ) {
          callback();
        } else {
          callback(new Error('不能为空！'));
        }
      } else {
        callback();
      }
    };
    let agentMsg = (rule, value, callback) => {
      if (value !== 0 && value < 3) {
        callback(new Error('代收货款不能小于3'));
      } else if (value > 10000) {
        callback(new Error('代收货款不能大于10000'));
      } else {
        callback();
      }
    };
    let supportMsg = (rule, value, callback) => {
      if (value !== 0 && value < 100) {
        callback(new Error('保价金额不能小于100'));
      } else if (value > 30000) {
        callback(new Error('保价金额不能大于30000'));
      } else {
        callback();
      }
    };
    let validateDistrictSend = (rule, value, callback) => {
      this.$nextTick(() => {
        let list = JSON.parse(
          JSON.stringify(this.areaListSend.districtList)
        ).filter((item) => {
          return item;
        });
        if (list.length > 2) {
          callback();
        } else {
          callback(new Error('请选择完整的省市区'));
        }
      });
    };
    let validateDistrictRecive = (rule, value, callback) => {
      this.$nextTick(() => {
        let list = JSON.parse(
          JSON.stringify(this.areaList.districtList)
        ).filter((item) => {
          return item;
        });
        if (list.length > 2) {
          callback();
        } else {
          callback(new Error('请选择完整的省市区'));
        }
      });
    };
    let logisticNoStr = (rule, value, callback) => {
      if (value !== '' && value !== undefined && value !== null) {
        value = value.replace(/(^\s*)|(\s*$)/g, '');
        let reg = /^[a-zA-Z0-9-_]*$/;
        if (value && value.length > 32) {
          callback(new Error('订单号长度限制32个字符'));
        } else if (value && !reg.test(value)) {
          callback(new Error('订单号只能包含字母和数字、下划线'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let goodsWeightStr = (rule, value, callback) => {
      if (value !== '' && value !== undefined && value !== null) {
        value = +value;
        if (value && value > 50) {
          callback(new Error('重量最大为50kg'));
        } else {
          callback();
        }
      } else {
        callback('请输入包裹重量');
      }
    };
    let valiReciveTime = (rule, value, callback) => {
      if (this.data.timedPickup == 1) {
        if (value && value.length) {
          callback();
        } else {
          callback(new Error('请选择上门取件时间'));
        }
      } else {
        callback();
      }
    };
    let valiSelectedTime = (rule, value, callback) => {
      if (this.data.timedPickup == 2) {
        if (value && value.length) {
          callback();
        } else {
          callback(new Error('请选择上门取件时间'));
        }
      } else {
        callback();
      }
    };
    let valiBrokerageFn = (rule, value, callback) => {
      if (this.data.isCheckedBrokerage) {
        if (value && value >= 0.5 && value <= 2) {
          if(value%0.5==0){
            callback();
          }else{
           return callback(new Error('请输入如 0.5、1、1.5、2返佣金额'));
          }
         
        } else {
         return callback(new Error('请输入付费返佣金额'));
        }
      } else {
        callback();
      }
    };
    return {
      activeFlag:false,
      realNameId:'',
      alipayName:'',
      isAliNameFlag: false,

      buyerPaysShippingDialogFlag: false,
      systemNumber: '', // 输入的平台订单号或运单号
      saveLoading: false,
      addressId:'',
      options: [],
      list: [],
      addrLoading: false,
      senderModel:'X',
      isCheckedAp: false,
      isCheckedAgent: false,
      isCheckedSupport: false,
      editId: '',
      editIdData: '',
      customCode: '',
      status: 'add',
      isShow: this.value,
      rememberOpt: {
        productName: false,
        count: false,
        weight: false,
        receiver: false,
        sender: false,
        remark: false,
      },
      areaListSend: {
        districtList: [],
        valueProvince: '',
        valueCity: '',
        valueDistrict: '',
        nameProvince: '',
        nameCity: '',
        nameDistrict: '',
      },
      areaList: {
        districtList: [],
        valueProvince: '',
        valueCity: '',
        valueDistrict: '',
        nameProvince: '',
        nameCity: '',
        nameDistrict: '',
      },
      data: {
        mallCode: '',
        customCode: '',
        apvalue: '',
        agentValue: '',
        supportPrice: '',
        district: [],
        districtSend: [],
        orderProducts: [
          {
            id: 1,
            goodName: '',
            goodNum: 1,
            goodUrl:'',
          },
        ],
        fromCityCode: '',
        fromCityName: '',
        fromDistrictCode: '',
        fromDistrictName: '',
        fromProvinceCode: '',
        fromProvinceName: '',
        toCityCode: '',
        toCityName: '',
        toDistrictCode: '',
        toDistrictName: '',
        toProvinceCode: '',
        toProvinceName: '',
        sendAddress: '',
        sendMobile: '',
        sendName: '',
        sendPhone: '',
        receiveName: '',
        receiveMobile: '',
        receivePhone: '',
        receiveAddress: '',
        checkedSender: false,
        checkedReceiver: false,
        mallOrderNo: null,
        brandName: '',
        packageNumber: 1,
        supportPrice: 0,
        productType: 0,
        receiveUnitAddress: '',
        sendUnitAddress: '',
        goodsWeight: 1,
        timedPickup: '1',
        reciveTime: [],
        selectedTime: [],
        mallRemark: '',
        isCheckedMerchanPay: true,
        isCheckedBrokerage: false,
        isCheckedPayType: false,
        brokerage: 0.5,
        payType: '100',
      },
      totalInfo: '',
      totalInfoSend: '',
      rules: {
        agentValue: [
          { required: false, message: '不能小于3', trigger: 'blur' },
          { validator: agentMsg, trigger: ['change', 'blur'] },
        ],
        supportPrice: [
          { required: false, message: '不能小于100', trigger: 'blur' },
          { validator: supportMsg, trigger: ['change', 'blur'] },
        ],
        receiveName: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { min: 1, max: 20, message: '限制输入20字符', trigger: 'blur' },
        ],
        receiveMobile: [
          { validator: valiMobile, trigger: ['blur', 'change'] },
        ],
        receivePhone: [
          { validator: valiPhone, trigger: ['blur', 'change'] },
        ],
        district: [
          {
            required: true,
            validator: validateDistrictRecive,
            trigger: 'change',
          },
        ],
        receiveAddress: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { min: 1, max: 255, message: '限制输入255字符', trigger: 'blur' },
          { validator: addressStr, trigger: ['blur'] }
        ],
        sendName: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { min: 1, max: 20, message: '限制输入20字符', trigger: 'blur' },
        ],
        sendMobile: [
          { validator: valiMobileSend, trigger: ['blur', 'change'] },
        ],
        sendPhone: [
          { validator: valiPhoneSend, trigger: ['blur', 'change'] },
        ],
        districtSend: [
          {
            required: true,
            validator: validateDistrictSend,
            trigger: 'change',
          },
        ],
        sendAddress: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { min: 1, max: 255, message: '限制输入255字符', trigger: 'blur' },
          { validator: addressStr, trigger: ['blur'] }
        ],
        'orderProducts[0].name': [
          { required: true, message: '不能为空', trigger: 'change' },
          { validator: specStrName, trigger: 'change' },
        ],
        mallOrderNo: [
          { validator: logisticNoStr, trigger: ['change', 'blur'] },
        ],
        goodsWeight: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { validator: goodsWeightStr, trigger: ['change', 'blur'] },
        ],
        reciveTime: [
          { validator: valiReciveTime, trigger: ['change', 'blur'] },
        ],
        selectedTime: [
          { validator: valiSelectedTime, trigger: ['change', 'blur'] },
        ],
        brokerage: [
          { validator: valiBrokerageFn, trigger: ['change', 'blur'] },
        ],
      },
      districtSend: [],
      district: [],
      senderOriginalInfo: {
        fromCityCode: '',
        fromCityName: '',
        fromDistrictCode: '',
        fromDistrictName: '',
        fromProvinceCode: '',
        fromProvinceName: '',
        sendAddress: '',
        sendMobile: '',
        sendName: '',
        sendPhone: '',
      },
      receiverOriginalInfo: {
        toCityCode: '',
        toCityName: '',
        toDistrictCode: '',
        toDistrictName: '',
        toProvinceCode: '',
        toProvinceName: '',
        receiveName: '',
        receiveMobile: '',
        receivePhone: '',
        receiveAddress: '',
      },
      productNameOpt: [],
      backupsData: [
        {
          id: null,
          productcode: 'P01',
          productname: '服饰',
          productshortname: null,
          productdesc: null,
          isDefault: null,
          creatuser: null,
          createtime: null,
          modifyuser: null,
          modifytime: null,
          isDel: 'N',
          pid: 'P01',
        },
        {
          id: null,
          productcode: 'P03',
          productname: '食品',
          productshortname: null,
          productdesc: null,
          isDefault: null,
          creatuser: null,
          createtime: null,
          modifyuser: null,
          modifytime: null,
          isDel: 'N',
          pid: 'P03',
        },
        {
          id: null,
          productcode: 'P02',
          productname: '生活用品',
          productshortname: null,
          productdesc: null,
          isDefault: null,
          creatuser: null,
          createtime: null,
          modifyuser: null,
          modifytime: null,
          isDel: 'N',
          pid: 'P02',
        },
        {
          id: null,
          productcode: 'P05',
          productname: '其他',
          productshortname: null,
          productdesc: null,
          isDefault: 'Y',
          creatuser: null,
          createtime: null,
          modifyuser: null,
          modifytime: null,
          isDel: 'N',
          pid: 'P05',
        },
        {
          id: null,
          productcode: 'P04',
          productname: '数码产品',
          productshortname: null,
          productdesc: null,
          isDefault: null,
          creatuser: null,
          createtime: null,
          modifyuser: null,
          modifytime: null,
          isDel: 'N',
          pid: 'P04',
        },
      ],
      isInputProductName: true,
      prodcutName: '',
      insuredServiceDialog: false,
      remarkForm: {
        remark: '',
      },
      remarkFormRule: {
        remark: [
          { required: true, message: '请输入备注内容', trigger: 'blur' },
        ],
      },
      senderList: [], // 发件人列表
      popoverRmark: false,
      remarkData: [],
      remarkLoading: false,
      addOptionsDialogVisble: false,
      natvieSotreList: [], // 本地店铺列表
      loading: false, //输入搜索
      inputGridDataSenders: [],
      sourceOperation:'',
      isSendHy: 'N',
      isReciveHy: 'N',
      beginResolveTime: 0, // 一键解析开始执行时间
      oldType: '-1', // 失焦解析标记
      showDialog: false, // 选择发件人 收件人弹窗
      dialogType: '', // 区分 选择发件人 收件人
      isShowIndentifyPicDialog: false, // 图片识别弹层
      identifyInfoType: '', // 图片识别参数
      imgUrl: '', // 上传的图片路径
      productTypeList: [
        {name: '普快', code: 0, type: 'PK', img: 'pk'},
        {name: '圆准达', code: 1000, type: 'YZD', img: 'yzd'},
        {name: '航空件', code: 9000, type: 'HKJ', img: 'hkj'},
        {name: '同城特快', code: 7000, type: 'XTCTK', img: 'tctk'},
      ],
      sendUploadedImage: '', // 用于存储上传图片的base64数据
      reciveUploadedImage: '', // 用于存储上传图片的base64数据
      showPrivacyDialog: false, // 下单协议
      balance: 0, // 账号余额
      estimatedFreight: 0, // 预估运费
      isShowPrivacy: false,
      isRefreshTime: true, // 是否更新取件时间
      isCheckedPrivacy: false,
      rewardCardBanlance: 0, // 优惠券金额
      activityInfo: {}, // 优惠活动信息
      buyerPaysOptions: [
        { label: '全额运费', value: '100' }
      ],

      isFirstResolveRecive: false, // 是否触发过自动解析收件人
      isFirstResolveSend: false, // 是否触发过自动解析发件人
    };
  },
  async created() {
    this.showPrivacyFn();
    let localData = localStorage.getItem('setSpecialOrderDraft');
    localData = localData ? JSON.parse(localData) : {};
    if (this.rowInfo && this.rowInfo.id) {
      this.senderModel = 'T';
      this.status = 'edit';
      this.editIdData = JSON.parse(JSON.stringify(this.rowInfo));
      await this.decryptAddressInfo(); // 收寄件人解密
    } else if (localData && localData.sendName) {
      this.senderModel = 'T';
      this.status = 'edit';
      this.editIdData = localData;
    }
    this.queryGoodsOptionsList();
    this.debouncedGetFreight = _.debounce(() => {
      this.getFreightFn();
    }, 500);
  },
  mounted() {
    this.init();
    // 激活一级菜单
    util.setActiveMenu('delivery');
  },
  
  methods: {
    goToRealName(){
      this.$emit('goToRealName')
    },
    UpDateAlyName(userName){
      this.$refs.buyerPaysShippingDialog.UpDateAlyName(userName)
    },
    openSaveAccount(realNameId){
      this.$emit('openSaveAccount',realNameId);
    },
    changeBrokerage(val){
      this.data.brokerage = val;
    },

    searchAlipayBindFn(){
      searchAlipayBindApi({}).then(res=>{
        console.log(res);
        if(res.message=='ok'&&res.data){
          //有支付宝账号说明已经实名
          if(res.data.userName){
            this.data.isCheckedBrokerage = true;
            this.data.isCheckedPayType  = false;
            this.data.payType = '100'   
            this.alipayName = res.data.userName;
            this.realNameId = res.data.realNameId;
            this.isAliNameFlag = true;
            this.data.brokerage = 0.5;
           
          }else{
            //没有绑定支付宝  是否实名制 已实名则现实绑定支付弹框 未实名则先实名
            if(res.data.realNameId){
              //未维护支付宝但已经实名 支付宝账号维护 
              this.$emit('openSaveAccount',res.data.realNameId)

            }else{
              this.$emit('openSaveAccount')
            }
          }     
        }else{
          this.$emit('openSaveAccount');
          this.isAliNameFlag = false;
          this.data.isCheckedBrokerage = false;
          //没有绑定支付宝，弹出绑定弹框
        }
      }).catch(err=>{
        this.$emit('openSaveAccount');
        this.isCheckedBrokerage = false;
        this.data.brokerage = 0.5;
        this.isAliNameFlag = false;
        // 没有绑定支付宝，弹出绑定弹框
        // this.$message.error(err.message)
      })
    },

    closeBuyerPaysShipping(){
      this.buyerPaysShippingDialogFlag = false;
    },
    openBrokerageFn(type){
      // type 1 返佣 2 全额运费      
      this.buyerPaysShippingDialogFlag = true;
      setTimeout(()=>{
        this.$refs.buyerPaysShippingDialog.initData(type,this.data.brokerage)
      },50);
    },

    viewBrokerageFn() {
      // 打开寄件人付费返佣详情弹层
    },
    viewPayTypeFn() {
      // 打开买家付运费弹层
    },
    checkedMerchanPaytFn() {
      this.data.isCheckedMerchanPay = !this.data.isCheckedMerchanPay;
      // 这里和寄件人付费互斥
      if (this.data.isCheckedMerchanPay) {
        this.data.isCheckedBrokerage = false;
        this.data.isCheckedPayType = false;
        this.data.brokerage = 0.5;
      } else if (!this.data.isCheckedBrokerage && !this.data.isCheckedPayType) {
        this.data.isCheckedMerchanPay = true;
      }
    },
    checkedBrokerageFn() {
      // 这里需要查一下当前账户是否开通了支付宝付款账户，若没有开通，不能勾选...
      // this.data.isCheckedBrokerage = !this.data.isCheckedBrokerage;
      // 这里和买家付运费互斥
      if (!this.data.isCheckedBrokerage) {
        // this.data.isCheckedPayType = false;
        // this.data.payType = '100';
        this.searchAlipayBindFn();
      }else{
        this.data.isCheckedBrokerage = false;
        this.data.brokerage = 0.5;      
      }
    },
    checkedPayTypeFn() {
      this.data.isCheckedPayType = !this.data.isCheckedPayType;
      // 这里和寄件人付费返佣互斥
      if (this.data.isCheckedPayType) {
        this.data.isCheckedBrokerage = false;
        this.data.brokerage = 0.5;
      }
    },
    // 收寄件人解密
    decryptAddressInfo() { 
      return new Promise((resolve, reject) => {
        let loadingMask = this.$loading({
          lockScroll: false,
          target: '.el-dialog__body',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        decryptUserInfoApi({...this.rowInfo, decryptType: '3'}).then(res => {
          loadingMask.close();
          if (res.success && res.data) {
            this.editIdData.sendName = res.data.sendName || '';
            this.editIdData.sendMobile = res.data.sendMobile || '';
            this.editIdData.sendPhone = res.data.sendPhone || '';
            this.editIdData.sendAddress = res.data.sendAddress || '';

            this.editIdData.receiveName = res.data.receiveName || '';
            this.editIdData.receiveMobile = res.data.receiveMobile || '';
            this.editIdData.receivePhone = res.data.receivePhone || '';
            this.editIdData.receiveAddress = res.data.receiveAddress || '';
          }
          resolve();
        }).catch(err => {
          loadingMask.close();
          resolve();
        });
      }); 
    },
    // 去授权店铺
    goAuthStoreFn() {
      this.$router.push({name: 'StoreManagement'});
    },
    initProductInfo() {
      let data = this.productNameOpt.filter(function (item) {
        return item.isDefault === 'Y';
      });
      let obj = {
        id: util.getUUID(8, 16),
        goodName: data.length ? data[0].productname : '',
        goodNum: 1,
        goodUrl: '',
      };
      return obj;
    },
    // 添加商品
    addProdcutInfoFn() {
      if(this.data.orderProducts.length >= 10) {
        this.$message.error('最多添加10个商品');
        return false;
      }
      let obj = this.initProductInfo();
      this.data.orderProducts.push(obj);
    },
    // 删除
    delProdcutInfoFn(index) {
      if (this.data.orderProducts.length == 1) {
        return
      }
      this.data.orderProducts.splice(index, 1);
    },
    // 删除图片
    removeImgUrl(index) {
      this.data.orderProducts[index].goodUrl = '';
    },
    // 预估运费计算
    getFreightFn() {
      // 在这里调用接口
      let requestParams = this.getParams();
      requestParams.bizType = '1';
      getEstimatedFreightForRetrunPickupApi(requestParams).then(res => {
        if (res.success && res.data && res.data.success) {
          this.estimatedFreight = res.data.estimatedFreight || 0;
        } else {
          this.estimatedFreight = 0;
        }
      }).catch(()=>{
        this.estimatedFreight = 0;
      })
    },
    // 选择取件时间--当日取
    selectedReciveTimeFn(selectedTime) {
      this.data.reciveTime = selectedTime;
    },
    // 选择取件时间--定时取
    selectedTimeFn(selectedTime) {
      this.data.selectedTime = selectedTime;
    },
    chageTimedPickupFn(label) {      
      let addressArr = this.receiveAddressInfo.split('|');
      if (!(addressArr.length > 2 && addressArr[0] && addressArr[1] && addressArr[2])) {
        this.$message.error('请输入收件地址后选择');
        return false;
      }
      if (label == 1) {
        if(this.$refs.selectedTimeComponent) {
          this.$refs.selectedTimeComponent.selectedTime = '';
        }
        this.data.timedPickup = [];
      } else if (label == 2) {
        if(this.$refs.reciveTimeComponent) {
          this.$refs.reciveTimeComponent.selectedTime = '';
        }
        this.data.reciveTime = [];
      }
      // 切换上门取件类型
      this.data.timedPickup = label;
    },
    validName(value,index){
     if(value){
      // 调用接口判断是否违禁品
      this.checkProductName(value).then(valid => {
        if (valid) { 
          this.$message.error('商品名称为违禁品'); 
          this.$set(this.data.orderProducts[index], 'goodName', '');
        }
      }).catch(error => {
        
      });
     } 
    },
    checkProductName(name){
      return new Promise((resolve, reject) => {
        validProductName(name).then(res => {
          console.log(res)
          if(res.status == '200'){
            resolve(res.data);
          }
          else {
            resolve('');
          }
        }).catch(() => {
          resolve('');
        });
      }
    );
    
    },
    clearSelect(index){
      // 用于控制下拉框的显示状态。当设置为 true 时，下拉框正常显示；
      this.$refs['el_auto_' + index][0].activated = true;
    },
    // 发件人切换选填
    changeSenderModel(val){
      this.senderModel = val;
      if(this.senderModel == 'T'){
        if(localStorage.getItem('sendInfoByX')){
          let sendInfoByX = localStorage.getItem('sendInfoByX');
          localStorage.removeItem('sendInfoByX');
          let addressDetail = JSON.parse(sendInfoByX);
          this.$set(this.data, 'fromCityCode', addressDetail.fromCityCode);
          this.$set(this.data, 'fromCityName', addressDetail.fromCityName);
          this.$set(this.data, 'fromDistrictCode', addressDetail.fromDistrictCode);
          this.$set(this.data, 'fromDistrictName', addressDetail.fromDistrictName);
          this.$set(this.data, 'fromProvinceCode', addressDetail.fromProvinceCode);
          this.$set(this.data, 'fromProvinceName', addressDetail.fromProvinceName);
          this.$set(this.data, 'sendAddress', addressDetail.sendAddress || '');
          this.$set(this.data, 'sendMobile', addressDetail.sendMobile || '');
          this.$set(this.data, 'sendName', addressDetail.sendName || '');
          this.$set(this.data, 'sendPhone', addressDetail.sendPhone || '');
          this.$set(this.data, 'sendUnitAddress', addressDetail.sendUnitAddress || '');

          this.$set(this.areaListSend, 'valueProvince', addressDetail.fromProvinceCode);
          this.$set(this.areaListSend, 'nameProvince', addressDetail.fromProvinceName);
          this.$set(this.areaListSend, 'valueCity', addressDetail.fromCityCode);
          this.$set(this.areaListSend, 'nameCity', addressDetail.fromCityName);
          this.$set(this.areaListSend, 'valueDistrict', addressDetail.fromDistrictCode);
          this.$set(this.areaListSend, 'nameDistrict', addressDetail.fromDistrictName);

          let list = [];
          if (addressDetail.fromProvinceCode) {
            list.push(addressDetail.fromProvinceCode);
          }
          if (addressDetail.fromCityCode) {
            list.push(addressDetail.fromCityCode);
          }
          if (addressDetail.fromDistrictCode) {
            list.push(addressDetail.fromDistrictCode);
          }
          this.$set(this.areaListSend, 'districtList', list);

          this.$nextTick(()=>{
            this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));

            this.senderOriginalInfo.sendName = addressDetail.sendName || '';
            this.senderOriginalInfo.sendMobile = addressDetail.sendMobile || '';
            this.senderOriginalInfo.sendPhone = addressDetail.sendPhone || '';
            this.senderOriginalInfo.sendAddress = addressDetail.sendAddress || '';

            this.senderOriginalInfo.fromDistrictCode = addressDetail.fromDistrictCode;
            this.senderOriginalInfo.fromCityCode = addressDetail.fromCityCode;
            this.senderOriginalInfo.fromProvinceCode = addressDetail.fromProvinceCode;
            this.senderOriginalInfo.fromDistrictName = addressDetail.fromDistrictName;
            this.senderOriginalInfo.fromCityName = addressDetail.fromCityName;
            this.senderOriginalInfo.fromProvinceName = addressDetail.fromProvinceName;

          })
        }else{
          // 获取发件人地址
          this.getAddress();
        }
      }else{
        let sendInfoByX = {
          fromCityCode: this.data.fromCityCode,
          fromCityName: this.data.fromCityName,
          fromDistrictCode: this.data.fromDistrictCode,
          fromDistrictName: this.data.fromDistrictName,
          fromProvinceCode: this.data.fromProvinceCode,
          fromProvinceName: this.data.fromProvinceName,
          sendAddress: this.data.sendAddress,
          sendMobile: this.data.sendMobile,
          sendName: this.data.sendName,
          sendPhone: this.data.sendPhone,
          areaListSend: this.areaListSend,
          sendUnitAddress: this.data.sendUnitAddress
        }
        localStorage.setItem('sendInfoByX',JSON.stringify(sendInfoByX))
        // 获取发件人地址
        this.getAddressList();
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.getAddressList(query, true);
      }
    },
    initAddrInfo(flag){
      if(flag){
        this.getAddressList();
      }else{
        if(this.options.length<1){
          this.getAddressList();
        }
      }
    },
    // 获取发件人选择下拉列表
    getAddressList(query, remote){
      this.addrLoading = true;
      let params = {
        isSend: true,
        pageNo: 1,
        limit: 3000,
        name: '',
        telephone: '',
        address: '',
      };
      if(remote){
        params.remarks = query;
      }
      getCustomerAddressApi(params).then((res) => {
        this.addrLoading = false;
        if (res.data && res.data.hasOwnProperty('total')) {
          let items = res.data.list;
          items.forEach((val) => {
            val.value = val.id
            val.label = `${val.name} ${val.mobile ? val.mobile : val.phone} ${val.provinceName}${val.cityName}${val.districtName}${val.address}`
          });
          this.options = items;
        } else {
          this.options = [];
        }
      }).catch(() => {
        this.addrLoading = false;
        this.options = [];
      }).finally(()=>{
        if(query){
          return
        }
        let addressList = this.options.filter((r)=>{
          if(r.value == this.addressId){
            return r
          }
        })
        if(addressList && addressList.length){
          this.addressId = addressList[0].value;
          this.$set(this.data, 'fromCityCode', addressList[0].cityCode);
          this.$set(this.data, 'fromCityName', addressList[0].cityName);
          this.$set(this.data, 'fromDistrictCode', addressList[0].districtCode);
          this.$set(this.data, 'fromDistrictName', addressList[0].districtName);
          this.$set(this.data, 'fromProvinceCode', addressList[0].provinceCode);
          this.$set(this.data, 'fromProvinceName',  addressList[0].provinceName);
          this.$set(this.data, 'sendAddress', addressList[0].address || '');
          this.$set(this.data, 'sendMobile', addressList[0].mobile || '');
          this.$set(this.data, 'sendName', addressList[0].name || '');
          this.$set(this.data, 'sendPhone', addressList[0].phone || '');
          this.$set(this.data, 'sendUnitAddress', addressList[0].company || '');

          this.$set(this.areaListSend, 'valueProvince', addressList[0].provinceCode);
          this.$set(this.areaListSend, 'nameProvince', addressList[0].provinceName);
          this.$set(this.areaListSend, 'valueCity', addressList[0].cityCode);
          this.$set(this.areaListSend, 'nameCity', addressList[0].cityName);
          this.$set(this.areaListSend, 'valueDistrict', addressList[0].districtCode);
          this.$set(this.areaListSend, 'nameDistrict', addressList[0].districtName);
          let list = [];
          if (addressList[0].provinceCode) {
            list.push(addressList[0].provinceCode);
          }
          if (addressList[0].cityCode) {
            list.push(addressList[0].cityCode);
          }
          if (addressList[0].districtCode) {
            list.push(addressList[0].districtCode);
          }
          this.$set(this.areaListSend, 'districtList', list);
          this.$refs.areaListSend && this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));

          let addressDetail = addressList[0];
          this.senderOriginalInfo.sendName = addressDetail.name || '';
          this.senderOriginalInfo.sendMobile = addressDetail.mobile || '';
          this.senderOriginalInfo.sendPhone = addressDetail.phone || '';
          this.senderOriginalInfo.sendAddress = addressDetail.address || '';
          this.senderOriginalInfo.fromDistrictCode = addressDetail.districtCode;
          this.senderOriginalInfo.fromCityCode = addressDetail.cityCode;
          this.senderOriginalInfo.fromProvinceCode = addressDetail.provinceCode;
          this.senderOriginalInfo.fromDistrictName = addressDetail.districtName;
          this.senderOriginalInfo.fromCityName = addressDetail.cityName;
          this.senderOriginalInfo.fromProvinceName = addressDetail.provinceName;

        }else if(this.options && this.options.length){
          this.addressId = this.options.length ? this.options[0].value:'';
          this.$set(this.data, 'fromCityCode', this.options[0].cityCode);
          this.$set(this.data, 'fromCityName', this.options[0].cityName);
          this.$set(this.data, 'fromDistrictCode', this.options[0].districtCode);
          this.$set(this.data, 'fromDistrictName', this.options[0].districtName);
          this.$set(this.data, 'fromProvinceCode', this.options[0].provinceCode);
          this.$set(this.data, 'fromProvinceName',  this.options[0].provinceName);
          this.$set(this.data, 'sendAddress', this.options[0].address || '');
          this.$set(this.data, 'sendMobile', this.options[0].mobile || '');
          this.$set(this.data, 'sendName', this.options[0].name || '');
          this.$set(this.data, 'sendPhone', this.options[0].phone || '');
          this.$set(this.data, 'sendUnitAddress', this.options[0].company || '');

          this.$set(this.areaListSend, 'valueProvince', this.options[0].provinceCode);
          this.$set(this.areaListSend, 'nameProvince', this.options[0].provinceName);
          this.$set(this.areaListSend, 'valueCity', this.options[0].cityCode);
          this.$set(this.areaListSend, 'nameCity', this.options[0].cityName);
          this.$set(this.areaListSend, 'valueDistrict', this.options[0].districtCode);
          this.$set(this.areaListSend, 'nameDistrict', this.options[0].districtName);
          let list = [];
          if (this.options[0].provinceCode) {
            list.push(this.options[0].provinceCode);
          }
          if (this.options[0].cityCode) {
            list.push(this.options[0].cityCode);
          }
          if  (this.options[0].districtCode) {
            list.push(this.options[0].districtCode);
          }
          this.$set(this.areaListSend, 'districtList', list);
          this.$refs.areaListSend && this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));


          let addressDetail = this.options[0];
          this.senderOriginalInfo.sendName = addressDetail.name || '';
          this.senderOriginalInfo.sendMobile = addressDetail.mobile || '';
          this.senderOriginalInfo.sendPhone = addressDetail.phone || '';
          this.senderOriginalInfo.sendAddress = addressDetail.address || '';
          this.senderOriginalInfo.fromDistrictCode = addressDetail.districtCode;
          this.senderOriginalInfo.fromCityCode = addressDetail.cityCode;
          this.senderOriginalInfo.fromProvinceCode = addressDetail.provinceCode;
          this.senderOriginalInfo.fromDistrictName = addressDetail.districtName;
          this.senderOriginalInfo.fromCityName = addressDetail.cityName;
          this.senderOriginalInfo.fromProvinceName = addressDetail.provinceName;
        }else{
          this.addressId = '';
        }
      });
    },
    querySearchAsyncRemark(queryString, cb) {
      let filterData = queryString
        ? this.remarkData.filter((item) => {
            return item.contents.includes(queryString);
          })
        : this.remarkData;
      filterData.map((item) => {
        return this.$set(item, 'value', item.contents);
      });
      cb(filterData);
    },
    handleSelectRemark(item) {
      this.data.mallRemark = item.contents.replace(/(^\s*)|(\s*$)/g, "");
    },
    // 自动填充必须要有value属性
    querySearchAsyncProduct(queryString, cb) {
      let filterData = queryString
        ? this.productNameOpt.filter((item) => {
            return item.productname.includes(queryString);
          })
        : this.productNameOpt;
      filterData.map((item) => {
        return this.$set(item, 'value', item.productname);
      });
      cb(filterData);
    },
    handleSelectRevice(item) {
      this.data.receiveName = item['data'].name;
      this.selectReceiver(item['data'], true);
    },
    querySearchAsyncRecive(queryString, cb) {
      let tempData = [];
      if (queryString !== '') {
        this.loading = true;
        let params = {
          isSend: false,
          pageNo: 1,
          limit: 100,
          name: queryString,
          telephone: '',
          address: '',
        };
        getCustomerAddressApi(params).then(res => {
          this.loading = false;
          if (res.data && res.data.hasOwnProperty('total')) {
            let items = res.data.list;
            this.inputGridDataSenders = items;
            this.inputGridDataSenders.forEach((val) => {
              tempData.push({
                value: `${val.name} ${val.mobile ? val.mobile : val.phone} ${val.provinceName}${val.cityName}${val.districtName}${val.address}${val.company ? '('+val.company+')' : ''}`,
                data: val,
              });
            });
            cb(tempData);
          } else {
            cb(tempData);
            this.inputGridDataSenders = [];
          }
        })
        .catch(() => {
          cb(tempData);
          this.inputGridDataSenders = [];
        });
      } else {
        cb(tempData);
      }
    },
    querySearchAsync(queryString, cb) {
      let tempData = [];
      if (queryString !== '') {
        this.loading = true;
        let params = {
          isSend: true,
          pageNo: 1,
          limit: 100,
          name: queryString,
          telephone: '',
          address: '',
        };
        getCustomerAddressApi(params).then(res => {
          this.loading = false;
          if (res.data && res.data.hasOwnProperty('total')) {
            let items = res.data.list;
            this.inputGridDataSenders = items;
            this.inputGridDataSenders.forEach((val) => {
              tempData.push({
                value: `${val.name} ${val.mobile ? val.mobile : val.phone} ${val.provinceName}${val.cityName}${val.districtName}${val.address}${val.company ? '('+val.company+')' : ''}`,
                data: val,
              });
            });
            cb(tempData);
          } else {
            cb(tempData);
            this.inputGridDataSenders = [];
          }
        })
        .catch(() => {
          cb(tempData);
          this.inputGridDataSenders = [];
        });
      } else {
        cb(tempData);
      }
    },
    handleSelectSender(item) {
      this.data.sendName = item['data'].name;
      this.selectSender(item['data']);
    },
    init() {
      this.getAccountInfo();
      this.getRewardCordInfo();
      this.getActivityInfo();
      this.getRemarkList();      
    },
    getAccountInfo() {
      this.balance = 0;
      queryAccountInfoApi({}).then(res => {
        if (res.status == 200 && res.data && res.data.list) {
          let list = res.data.list || [];
          let balance = list.length ? list[0].balance : 0;
          this.balance = balance;
        }
      })
    },
    getRewardCordInfo() {
      this.rewardCardBanlance = 0;
      queryRewardCordApi({}).then(res => {
        if (res.status == 200 && res.data?.length) {
          let data = res.data[0];
          this.rewardCardBanlance = data.balance;
        }
      })
    },
    getActivityInfo() {
      this.activityInfo = {};
      searchActivityApi({}).then(res => {
        // 根据res.time 和 endDate

        if (res.status == 200 && res.data) {
          // res.time = "2027-12-05 14:31:08"
          let data = JSON.parse(res.data);
          this.activityInfo = data || {};
          if(new Date(res.time).getTime() <= new Date(data.endDate).getTime()){
            this.activeFlag = true;
          }else{
            this.activeFlag = false;
          }
        }else{
          this.activeFlag = false;
        }
      }).finally(()=>{
        this.$emit('hasActiveAuth',this.activeFlag)
      })
    },
    showPrivacyFn() {
      queryListByTypeApi({pactType: 'returnPickupPrivacy'}).then(res => {
        if (res.status == 200 && res.data.length) {
          let list = res.data.filter(t => { return t.pactType == 'returnPickupPrivacy'; });
          if (list.length) {
            // 已阅读隐私协议
            this.isShowPrivacy = true;
            this.isCheckedPrivacy = true;
          } else {
            this.isShowPrivacy = false;
            this.isCheckedPrivacy = false;
          }
        } else {
          this.isShowPrivacy = false;
          this.isCheckedPrivacy = false;
        }
      }).catch(()=>{
        this.isShowPrivacy = false;
        this.isCheckedPrivacy = false;
      });
    },
    queryGoodsOptionsList() {
      let params = {
        userId: this.userMess.loginId,
      };
      queryGoodsOptionsListApi(params).then((res) => {
        if (res.success) {
          this.productNameOpt =  res.data && res.data.length > 0 ? res.data : this.backupsData;
        } else {
          this.productNameOpt = this.backupsData;
        }
      })
      .catch(() => {
        this.productNameOpt = this.backupsData;
      })
      .finally(() => {
        this.openDialog();
      });
    },
    // 一键解析失焦时触发
    blurAddr(type){
      if(type == 'send' && this.isFirstResolveSend) {
        return;
      } else if(type == 'receive' && this.isFirstResolveRecive) {
        return;
      }
      // 使用 Date.now() 获取完整毫秒时间戳，避免 getMilliseconds() 仅返回 0-999 导致跨秒比较失真
      this.beginResolveTime = Date.now();
      if(type == 'send' && this.totalInfoSend){
        this.smartResolve('send', 'blur');
      }else if(type == 'receive' && this.totalInfo){
        this.smartResolve('receive', 'blur');
      }
    },
    // 一键解析
    async smartResolve(type, flag) {
      // 事件节流：失焦(blur)与按钮点击(click)可能在极短时间内同时触发，需保证只执行一次。
      // 使用 Date.now() 获取完整毫秒时间戳，避免 getMilliseconds() 仅返回 0-999 导致跨秒比较失真。
      const now = Date.now();
      // 场景一：同时触发两次失焦事件（不同类型）时，只调用一次。
      // now 与 beginResolveTime 差值极小（≤5ms）即视为"同一时刻"触发，加容差避免跨毫秒边界偶发漏判。
      if (flag == 'blur' && now - this.beginResolveTime <= 5 && this.oldType != type && this.oldType != '-1') {
        this.oldType = '-1';
        this.beginResolveTime = 0;
        return false;
      }
      // 场景二：失焦事件已执行时，200ms 内触发的按钮点击视为重复，不再执行。
      if (flag != 'blur' && this.beginResolveTime != 0 && now - this.beginResolveTime < 200) {
        this.beginResolveTime = 0;
        return false;
      }
      this.oldType = type;
      // let domList = document.querySelectorAll('div.el-cascader');
      let params = null;
      if (type === 'send') {
        if(this.totalInfoSend.trim() == '') {
          return;
        } else {
          params = [
            {
              addressDetail: this.totalInfoSend,
              objectId: 0
            }
          ]
        }
      }
      if (type === 'receive') {
        if(this.totalInfo.trim() == '') {
          return;
        } else {
          params = [
            {
              addressDetail: this.totalInfo,
              objectId: 0
            }
          ]
        }
      }
      let mess = await addressResolutionApi(params);
      let validStatus = false; // 返回值是否有效的标记
      let validKeyList = ['name', 'province', 'city', 'county', 'addressDetail']; // 需要检测有没有value的key
      let resultdata = mess[0] || {};
      Object.keys(resultdata).forEach(key => {
        if(key === 'telephones') {
          if(resultdata[key] && resultdata[key].length >= 1) {
            validStatus = true;
          }
        } else {
          if(validKeyList.includes(key)) {
            if(resultdata[key]) {
              validStatus = true;
            }
          }
        }
      })
      if(!validStatus) {
        // 说明返回值均无效 null
        this.$confirm('地址不完整，请检查解析是否正确', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false,
        });
        return;
      }
      this.beginResolveTime = 0;
      this.oldType = '-1'; // 成功解析后复位，避免下一次不同类型的失焦被场景一误抑制

      let mobileNumber = ''; // 手机号
      let phoneNumber = ''; // 电话号
      let telephonesArr = resultdata.telephones;
      if(telephonesArr && telephonesArr.length > 1) {
        // telephones数据大于2条
        if(isMobileNumber(telephonesArr[0])) {
          mobileNumber = telephonesArr[0] || '';
          phoneNumber = telephonesArr[1] || '';
        } else {
          phoneNumber = telephonesArr[0] || '';
          mobileNumber = telephonesArr[1] || '';
        }
      } else if(telephonesArr && telephonesArr.length == 1) {
        // telephones数据只有1条，需要判断是手机号还是电话号
        if(isMobileNumber(telephonesArr[0])) {
          // 是手机号
          mobileNumber = telephonesArr[0] || '';
        } else {
          // 是电话号
          if(telephonesArr[0].length==10&&telephonesArr[0].startsWith('1')){
            mobileNumber = telephonesArr[0] || '';
          }else{
            phoneNumber = telephonesArr[0] || '';
          }
        }
      }

      if (type === 'send') {
        this.isFirstResolveSend = true; // 是否已触发过自动解析发件人
        this.$set(this.data, 'sendName', resultdata.name);
        this.$set(this.data, 'sendMobile', mobileNumber);
        this.$set(this.data, 'sendPhone', phoneNumber);
        this.$set(this.data, 'sendAddress', resultdata.addressDetail || '');
        
        if (resultdata.province || resultdata.city) {
          this.data.districtSend = [
            resultdata.provinceCode,
            resultdata.cityCode,
            resultdata.countyCode,
          ];
          this.data.fromDistrictCode = resultdata.countyCode;
          this.data.fromCityCode = resultdata.cityCode;
          this.data.fromProvinceCode = resultdata.provinceCode;
          this.data.fromDistrictName = resultdata.county;
          this.data.fromCityName = resultdata.city;
          this.data.fromProvinceName = resultdata.province;

          // 回显省市区组件
          this.$set(this.areaListSend, 'valueProvince', resultdata.provinceCode);
          this.$set(this.areaListSend, 'nameProvince', resultdata.province);
          this.$set(this.areaListSend, 'valueCity', resultdata.cityCode);
          this.$set(this.areaListSend, 'nameCity', resultdata.city);
          this.$set(this.areaListSend, 'valueDistrict', resultdata.countyCode);
          this.$set(this.areaListSend, 'nameDistrict', resultdata.county);
          let list = [];
          if (resultdata.provinceCode) {
            list.push(resultdata.provinceCode);
          }
          if (resultdata.cityCode) {
            list.push(resultdata.cityCode);
          }
          if (resultdata.countyCode) {
            list.push(resultdata.countyCode);
          }
          this.$set(this.areaListSend, 'districtList', list);
          this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));
        } else {
          this.data.districtSend = ['', '', ''];
          this.data.fromDistrictCode = '';
          this.data.fromCityCode = '';
          this.data.fromProvinceCode = '';
          this.data.fromDistrictName = '';
          this.data.fromCityName = '';
          this.data.fromProvinceName = '';
          // domList[0].querySelector('input.el-input__inner').value = '';

          // 回显省市区组件
          this.$set(this.areaListSend, 'valueProvince', '');
          this.$set(this.areaListSend, 'nameProvince', '');
          this.$set(this.areaListSend, 'valueCity', '');
          this.$set(this.areaListSend, 'nameCity', '');
          this.$set(this.areaListSend, 'valueDistrict', '');
          this.$set(this.areaListSend, 'nameDistrict', '');
          this.$set(this.areaListSend, 'districtList', []);
          this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));
        }
      } else {
        this.isFirstResolveRecive = true; // 是否已触发过自动解析收件人
        this.$set(this.data, 'receiveName', resultdata.name);
        this.$set(this.data, 'receiveMobile', mobileNumber);
        this.$set(this.data, 'receivePhone', phoneNumber);
        this.$set(this.data, 'receiveAddress', resultdata.addressDetail || '');

        if (resultdata.province || resultdata.city) {
          this.data.district = [
            resultdata.provinceCode,
            resultdata.cityCode,
            resultdata.countyCode,
          ];
          this.data.toDistrictCode = resultdata.countyCode;
          this.data.toCityCode = resultdata.cityCode;
          this.data.toProvinceCode = resultdata.provinceCode;
          this.data.toDistrictName = resultdata.county;
          this.data.toCityName = resultdata.city;
          this.data.toProvinceName = resultdata.province;

          // 回显省市区组件
          this.$set(this.areaList, 'valueProvince', resultdata.provinceCode);
          this.$set(this.areaList, 'nameProvince', resultdata.province);
          this.$set(this.areaList, 'valueCity', resultdata.cityCode);
          this.$set(this.areaList, 'nameCity', resultdata.city);
          this.$set(this.areaList, 'valueDistrict', resultdata.countyCode);
          this.$set(this.areaList, 'nameDistrict', resultdata.county);
          let list = [];
          if (resultdata.provinceCode) {
            list.push(resultdata.provinceCode);
          }
          if (resultdata.cityCode) {
            list.push(resultdata.cityCode);
          }
          if (resultdata.countyCode) {
            list.push(resultdata.countyCode);
          }
          this.$set(this.areaList, 'districtList', list);
          this.$refs.areaList.getArea(JSON.stringify(this.areaList));
        } else {
          this.data.district = ['', '', ''];
          this.data.toDistrictCode = '';
          this.data.toCityCode = '';
          this.data.toProvinceCode = '';
          this.data.toDistrictName = '';
          this.data.toCityName = '';
          this.data.toProvinceName = '';
          // domList[1].querySelector('input.el-input__inner').value = '';

          // 回显省市区组件
          this.$set(this.areaList, 'valueProvince', '');
          this.$set(this.areaList, 'nameProvince', '');
          this.$set(this.areaList, 'valueCity', '');
          this.$set(this.areaList, 'nameCity', '');
          this.$set(this.areaList, 'valueDistrict', '');
          this.$set(this.areaList, 'nameDistrict', '');
          this.$set(this.areaList, 'districtList', []);
          this.$refs.areaList.getArea(JSON.stringify(this.areaList));
        }
      }
    },
    // 清除内容
    clear() {
      this.districtOptions = [];
      this.totalInfo = '';
      for (let k in this.rememberOpt) {
        this.$set(this.rememberOpt, k, false);
      }
      for (let k in this.data) {
        if (k === 'orderProducts') {
          this.data.orderProducts = this.data.orderProducts[0];
          let data = this.data.orderProducts[0];
          for (let k in data) {
            this.$set(data, k, '');
          }
        } else {
          if (k === 'district') {
            this.$set(this.data, k, []);
          } else {
            this.$set(this.data, k, '');
          }
        }
      }
    },
    // 保存
    finishGoOn(type) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.isCheckedPrivacy && !this.isShowPrivacy) {
            this.$message.error('请勾选隐私协议！');
            return false;
          }
          this.save((saveData) => {            
            // 没有记住隐私协议时，需要接口记忆已阅读
            if (!this.isCheckedPrivacy) {
              insertConfirmRecordApi({pactType: 'returnPickupPrivacy'});
            }

            if(localStorage.getItem('sendInfoByX')){
              localStorage.removeItem('sendInfoByX');
            }
            
            this.$nextTick(() => {
              this.$refs['ruleForm'].clearValidate();
              if (type == 'print') {
                // 保存并打印
                this.$emit('goApplyOrder', [saveData]);
              } else {
                this.$emit('goApplyOrder');
              }
            });            
          });
        } else {
          return false;
        }
      });
    },
    // 比较发件人信息和收件人信息是否完全一样，决定是否传 保存至地址薄选项
    compareSenderInfoAndReciveInfo() {
      let obj = { reciverFlag: true, senderFlag: true };
      if (
        this.receiverOriginalInfo.toCityName === this.data.toCityName &&
        this.receiverOriginalInfo.toProvinceName === this.data.toProvinceName &&
        this.receiverOriginalInfo.toDistrictName === this.data.toDistrictName &&
        this.receiverOriginalInfo.receiveName === this.data.receiveName &&
        this.receiverOriginalInfo.receiveMobile === this.data.receiveMobile &&
        this.receiverOriginalInfo.receivePhone === this.data.receivePhone &&
        this.receiverOriginalInfo.receiveAddress === this.data.receiveAddress
      ) {
        obj.reciverFlag = false;
      }
      if (
        this.senderOriginalInfo.fromCityName === this.data.fromCityName &&
        this.senderOriginalInfo.fromProvinceName === this.data.fromProvinceName &&
        this.senderOriginalInfo.fromDistrictName === this.data.fromDistrictName &&
        this.senderOriginalInfo.sendName === this.data.sendName &&
        this.senderOriginalInfo.sendMobile === this.data.sendMobile &&
        this.senderOriginalInfo.sendPhone === this.data.sendPhone &&
        this.senderOriginalInfo.sendAddress === this.data.sendAddress
      ) {
        obj.senderFlag = false;
      }
      return obj;
    },
    getParams(){
      if(this.senderModel == 'X'){
        let addressList = this.options.filter((r)=>{
          if(r.value == this.addressId){
            return r
          }
        })
        if(addressList && addressList.length){
          this.$set(this.data, 'fromCityCode', addressList[0].cityCode);
          this.$set(this.data, 'fromCityName', addressList[0].cityName);
          this.$set(this.data, 'fromDistrictCode', addressList[0].districtCode);
          this.$set(this.data, 'fromDistrictName', addressList[0].districtName);
          this.$set(this.data, 'fromProvinceCode', addressList[0].provinceCode);
          this.$set(this.data, 'fromProvinceName',  addressList[0].provinceName);
          this.$set(this.data, 'sendAddress', addressList[0].address || '');
          this.$set(this.data, 'sendMobile', addressList[0].mobile || '');
          this.$set(this.data, 'sendName', addressList[0].name || '');
          this.$set(this.data, 'sendPhone', addressList[0].phone || '');
          this.$set(this.data, 'sendUnitAddress', addressList[0].company || '');
        } else {
          this.saveLoading = false;
          this.$message.error('发件人信息不能为空');
          return false;
        }
      }
      this.data.mallRemark = this.data.mallRemark && this.data.mallRemark.replace(/(^\s*)|(\s*$)/g, "")
      if (this.data.mallRemark && this.data.mallRemark.length > 100) {
        this.saveLoading = false;
        this.$message.error('订单备注最多支持100个字符');
        return false;
      }
        let checkedStatus = this.compareSenderInfoAndReciveInfo();
                
        let params = {
          returnPickupOrderDto: {
            sendCityCode: this.data.fromCityCode || '',
            sendCity: this.data.fromCityName || '',
            sendCountyCode: this.data.fromDistrictCode,
            sendCounty: this.data.fromDistrictName || '',
            sendProvinceCode: this.data.fromProvinceCode || '',
            sendProvince: this.data.fromProvinceName || '',
            sendName: this.data.sendName,
            sendMobile: this.data.sendMobile,
            sendPhone: this.data.sendPhone,
            sendAddress: this.data.sendAddress.replace(/(^\s*)|(\s*$)/g, ""),
            sendUnitAddress: this.data.sendUnitAddress,

            receiveCityCode: this.data.toCityCode || '',
            receiveCity: this.data.toCityName || '',
            receiveCountyCode: this.data.toDistrictCode,
            receiveCounty: this.data.toDistrictName || '',
            receiveProvinceCode: this.data.toProvinceCode || '',
            receiveProvince: this.data.toProvinceName || '',
            receiveName: this.data.receiveName,
            receivePhone: this.data.receivePhone,
            receiveMobile: this.data.receiveMobile,
            receiveAddress: this.data.receiveAddress.replace(/(^\s*)|(\s*$)/g, ""),
            receiveUnitAddress: this.data.receiveUnitAddress,
            
            remark: this.data.mallRemark,
            orderType: 'RETURN',
            estimatedWeight: this.data.goodsWeight, // 预估重量
            goodDtoList: this.data.orderProducts, // 商品信息
          },
          bindBizStaffCode: this.bindSellerInfo.bindCode || '',
          createType: 0, //0页面添加，1智能不包含发件人，2智能包含发件人,3标准不包含发件人，4标准包含发件人          
          pickUpOrderType: this.data.timedPickup == 1 ? '0' : this.data.timedPickup, // 0当日取， 2 定时取
          dayFlag: '',
          timeRange: '', 
          checkedSender: checkedStatus.senderFlag ? this.data.checkedSender : false, // 是否将发件人保存到地址簿
        };
        if (this.data.timedPickup == 1) {
          // 当日取
          let timeArr = this.data.reciveTime;
          params.dayFlag = timeArr[0];
          params.timeRange = timeArr[1];
        } else {
          // 定时取
          let timeArr = this.data.selectedTime;
          params.dayFlag = timeArr[0];
          params.timeRange = timeArr[1];
        }

        if (this.data.isCheckedBrokerage) {
          params.brokerage = this.data.brokerage;
          params.payType = '100';
        }
        if (this.data.isCheckedPayType) {
          params.payType = this.data.payType;
          params.brokerage = 0;
        }
        console.log('params====', params)
        return params;
    },
    // 保存订单内容
    save(callback) {
      this.isFirstResolveRecive = false; // 是否触发过自动解析收件人
      this.isFirstResolveSend = false; // 是否触发过自动解析发件人
      let params = this.getParams();
      this.saveLoading = true;
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      if(params){
        this.createOrderFn(loadingMask, params, callback);
      } else {
        this.saveLoading = false;
        loadingMask.close();
      }
    },
    createOrderFn(loadingMask, params, callback) {
      createSpecialOrderApi(params).then((res) => {
        if (res.success && res.data && res.data.success) {
          loadingMask.close();
          this.saveLoading = false;
          this.$message({
            type: 'success',
            message: '添加订单成功！',
          });
          if (params.checkedSender) {
            let reciveInfo = params.returnPickupOrderDto;
            // 收件人保存地址簿
            let reciveParams = {
              address: reciveInfo.sendAddress,
              isDefault: false,
              isSend: true,
              mobile: reciveInfo.sendMobile,
              phone: reciveInfo.sendPhone,
              name: reciveInfo.sendName,
              provinceCode: reciveInfo.sendProvinceCode,
              cityCode: reciveInfo.sendCityCode,
              districtCode: reciveInfo.sendCountyCode,
              provinceName: reciveInfo.sendProvince,
              cityName: reciveInfo.sendCity,
              districtName: reciveInfo.sendCounty,
              company: reciveInfo.sendUnitAddress
            };
            addAddressApi(reciveParams);
          }
          if (callback) {
            callback(res.data);
          }
          localStorage.removeItem('setSpecialOrderDraft');
        } else {
          let failMsg = (res.data && res.data.failMsg) || res.message;
          if (failMsg) {
            if (failMsg.indexOf('充值') > -1 || failMsg.indexOf('余额') > -1) {
              loadingMask.close();
              this.saveLoading = false;
              this.$confirm(failMsg, '提示', {
                confirmButtonText: '去充值',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                localStorage.setItem('setSpecialOrderDraft', JSON.stringify(this.data));
                // 这里要跳转到充值....
                this.$router.push({
                  name: 'specialAccountIndex',
                  params: {
                    from: 'thj',
                  }
                })
              })
            } else if (failMsg.indexOf('地址禁止') > -1) {
              loadingMask.close();
              this.saveLoading = false;
              this.$confirm(failMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                //....
              })
            } else {
              let tipsStr = '';
              if (res.message == 'STHJ5000000001') {
                tipsStr = '当前绑定的专属业务员已失效，是否继续寄件？继续寄件将分给其他业务员取件。';
              } else if (res.message == 'STHJ5000000002') {
                tipsStr = '当前寄件地址与绑定的专属业务员揽派范围不一致，是否继续寄件？继续寄件将分给其他业务员取件。'
              }
              if (tipsStr) {
                this.$confirm(tipsStr, '提示', {
                  confirmButtonText: '继续',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  let paramsBak = JSON.parse(JSON.stringify(params));
                  delete paramsBak.bindBizStaffCode;
                  this.createOrderFn(loadingMask, paramsBak, callback);
                }).catch(() => {
                  loadingMask.close();
                  this.saveLoading = false;
                  return false;
                });
              } else {
                loadingMask.close();
                this.saveLoading = false;
                this.$message.error(failMsg || '订单创建失败');
              }
            }
          } else {
            loadingMask.close();
            this.saveLoading = false;
            this.$message.error(res.message || '订单创建失败');
          }
        }
      }).catch((err) => {
        loadingMask.close();
        this.saveLoading = false;
        this.$message.error(err.error);
      });
    },
    // 改变区域后将区域信息存入data
    changeRegion(list) {
      let areaList = JSON.parse(list);
      // 页面父组件赋值
      this.$set(this.data, 'toProvinceCode', areaList.valueProvince);
      this.$set(this.data, 'toProvinceName', areaList.nameProvince);
      this.$set(this.data, 'toCityCode', areaList.valueCity);
      this.$set(this.data, 'toCityName', areaList.nameCity);
      this.$set(this.data, 'toDistrictCode', areaList.valueDistrict);
      this.$set(this.data, 'toDistrictName', areaList.nameDistrict);
      // 页面子组件赋值
      this.$set(this.areaList, 'valueProvince', areaList.valueProvince);
      this.$set(this.areaList, 'nameProvince', areaList.nameProvince);
      this.$set(this.areaList, 'valueCity', areaList.valueCity);
      this.$set(this.areaList, 'nameCity', areaList.nameCity);
      this.$set(this.areaList, 'valueDistrict', areaList.valueDistrict);
      this.$set(this.areaList, 'nameDistrict', areaList.nameDistrict);
      this.$set(
        this.areaList,
        'districtList',
        JSON.parse(areaList.districtList)
      );
      this.$refs['ruleForm'].validateField('district');
    },
    // 改变区域后将区域信息存入data
    changeRegionSend(list) {
      let areaList = JSON.parse(list);
      // 页面父组件赋值
      this.$set(this.data, 'fromProvinceCode', areaList.valueProvince);
      this.$set(this.data, 'fromProvinceName', areaList.nameProvince);
      this.$set(this.data, 'fromCityCode', areaList.valueCity);
      this.$set(this.data, 'fromCityName', areaList.nameCity);
      this.$set(this.data, 'fromDistrictCode', areaList.valueDistrict);
      this.$set(this.data, 'fromDistrictName', areaList.nameDistrict);
      // 页面子组件赋值
      this.$set(this.areaListSend, 'valueProvince', areaList.valueProvince);
      this.$set(this.areaListSend, 'nameProvince', areaList.nameProvince);
      this.$set(this.areaListSend, 'valueCity', areaList.valueCity);
      this.$set(this.areaListSend, 'nameCity', areaList.nameCity);
      this.$set(this.areaListSend, 'valueDistrict', areaList.valueDistrict);
      this.$set(this.areaListSend, 'nameDistrict', areaList.nameDistrict);
      this.$set(
        this.areaListSend,
        'districtList',
        JSON.parse(areaList.districtList)
      );
      this.$refs['ruleForm'].validateField('districtSend');
    },
    // 选中发件人
    selectSender(row) {
      this.data.sendUnitAddress = row.company || '';
      this.data.sendName = row.name;
      this.data.sendMobile = row.mobile;
      this.data.sendPhone = row.phone;
      this.data.sendAddress = row.address;
      // 备份发件人信息，用于与最终提交的数据做对比，如果地址没有变更，便不保存至地址薄
      this.senderOriginalInfo.sendName = row.name;
      this.senderOriginalInfo.sendMobile = row.mobile;
      this.senderOriginalInfo.sendPhone = row.phone;
      this.senderOriginalInfo.sendAddress = row.address;
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      getDistrictPathUpApi({ id: row.districtCode })
        .then(({ levelCodePath, levelNamePath }) => {
          loadingMask.close();
          levelCodePath = levelCodePath.replace('DIST_INTERNAL/', '');
          levelCodePath = levelCodePath.replace('DIST_KUAIBAO_0/', '');
          levelNamePath = levelNamePath.replace('大陆/', '');
          let listCode = levelCodePath.split('/');
          let listName = levelNamePath.split('/');
          this.data.fromDistrictCode = listCode[2];
          this.data.fromCityCode = listCode[1];
          this.data.fromProvinceCode = listCode[0];
          this.data.fromDistrictName = listName[2];
          this.data.fromCityName = listName[1];
          this.data.fromProvinceName = listName[0];

          // 回显省市区组件
          this.$set(this.areaListSend, 'valueProvince', listCode[0]);
          this.$set(this.areaListSend, 'nameProvince', listName[0]);
          this.$set(this.areaListSend, 'valueCity', listCode[1]);
          this.$set(this.areaListSend, 'nameCity', listName[1]);
          this.$set(this.areaListSend, 'valueDistrict', listCode[2]);
          this.$set(this.areaListSend, 'nameDistrict', listName[2]);
          this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));          
          if (listName[0] == '海外') {
            this.isSendHy = 'Y';
          } else {
            this.isSendHy = 'N';
          }
          // 备份发件人信息，用于与最终提交的数据做对比，如果地址没有变更，便不保存至地址薄
          this.senderOriginalInfo.fromDistrictCode = listCode[2];
          this.senderOriginalInfo.fromCityCode = listCode[1];
          this.senderOriginalInfo.fromProvinceCode = listCode[0];
          this.senderOriginalInfo.fromDistrictName = listName[2];
          this.senderOriginalInfo.fromCityName = listName[1];
          this.senderOriginalInfo.fromProvinceName = listName[0];
          document.querySelector('.el-main').click();
        })
        .catch(() => {
          loadingMask.close();
        });
    },
    // 选中收件人
    selectReceiver(row) {
      this.data.receiveUnitAddress = row.company || '';
      this.data.receiveName = row.name;
      this.data.receiveMobile = row.mobile;
      this.data.receivePhone = row.phone;
      this.data.receiveAddress = row.address;
      // 备份发件人信息，用于与最终提交的数据做对比，如果地址没有变更，便不保存至地址薄
      this.receiverOriginalInfo.receiveName = row.name;
      this.receiverOriginalInfo.receiveMobile = row.mobile;
      this.receiverOriginalInfo.receivePhone = row.phone;
      this.receiverOriginalInfo.receiveAddress = row.address;
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      getDistrictPathUpApi({ id: row.districtCode })
        .then(({ levelCodePath, levelNamePath }) => {
          loadingMask.close();
          levelCodePath = levelCodePath.replace('DIST_INTERNAL/', '');
          levelCodePath = levelCodePath.replace('DIST_KUAIBAO_0/', '');
          levelNamePath = levelNamePath.replace('大陆/', '');
          let listCode = levelCodePath.split('/');
          let listName = levelNamePath.split('/');
          this.data.toDistrictCode = listCode[2];
          this.data.toCityCode = listCode[1];
          this.data.toProvinceCode = listCode[0];
          this.data.toDistrictName = listName[2];
          this.data.toCityName = listName[1];
          this.data.toProvinceName = listName[0];
          // 备份发件人信息，用于与最终提交的数据做对比，如果地址没有变更，便不保存至地址薄
          this.receiverOriginalInfo.toDistrictCode = listCode[2];
          this.receiverOriginalInfo.toCityCode = listCode[1];
          this.receiverOriginalInfo.toProvinceCode = listCode[0];
          this.receiverOriginalInfo.toDistrictName = listName[2];
          this.receiverOriginalInfo.toCityName = listName[1];
          this.receiverOriginalInfo.toProvinceName = listName[0];

          // 回显省市区组件
          this.$set(this.areaList, 'valueProvince', listCode[0]);
          this.$set(this.areaList, 'nameProvince', listName[0]);
          this.$set(this.areaList, 'valueCity', listCode[1]);
          this.$set(this.areaList, 'nameCity', listName[1]);
          this.$set(this.areaList, 'valueDistrict', listCode[2]);
          this.$set(this.areaList, 'nameDistrict', listName[2]);
          this.$set(this.areaList, 'districtList', listCode);
          this.$refs.areaList.getArea(JSON.stringify(this.areaList));
          if (listName[0] == '海外') {
            this.isReciveHy = 'Y';
          } else {
            this.isReciveHy = 'N';
          }
          document.querySelector('.el-main').click();
        })
        .catch(() => {
          loadingMask.close();
        });
    },
    // 获取收件人地址
    getAddress(){
      // 默认的发件人 > 第一条数据
      getCustomerAddressApi({
        isSend: true,
        pageNo: 1,
        limit: 10000,
      }).then(res => {
        this.senderList = (res.data && res.data.list) ? res.data.list : [];
        if(this.senderList && this.senderList.length){
          let item = this.senderList[0];
          getDistrictPathUpApi({ id: item.districtCode }).then(({ levelNamePath, levelCodePath }) => {
              this.$nextTick(() => {
                let cityName = levelNamePath ? levelNamePath.replace('大陆/', '') : '';
                let cityCode = levelCodePath ? levelCodePath.replace('DIST_INTERNAL/', '').replace('DIST_KUAIBAO_0/', '') : '';
                let sendCityList = cityName ? cityName.split('/') : [];
                let sendCityCodeList = cityCode ? cityCode.split('/') : [];
                this.district = sendCityCodeList;
                this.data.district = [];

                this.$set(this.data, 'fromCityCode', sendCityCodeList[1]);
                this.$set(this.data, 'fromCityName', sendCityList[1]);
                this.$set(this.data, 'fromDistrictCode', sendCityCodeList[2]);
                this.$set(this.data, 'fromDistrictName', sendCityList[2]);
                this.$set(this.data, 'fromProvinceCode', sendCityCodeList[0]);
                this.$set(this.data, 'fromProvinceName', sendCityList[0]);

                this.$set(this.areaListSend, 'valueProvince', sendCityCodeList[0]);
                this.$set(this.areaListSend, 'nameProvince', sendCityList[0]);
                this.$set(this.areaListSend, 'valueCity', sendCityCodeList[1]);
                this.$set(this.areaListSend, 'nameCity', sendCityList[1]);
                this.$set(this.areaListSend, 'valueDistrict', sendCityCodeList[2]);
                this.$set(this.areaListSend, 'nameDistrict', sendCityList[2]);
                this.$set(this.areaListSend, 'districtList', sendCityCodeList);
                this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));
                
              });
            });
          this.$set(this.data, 'sendAddress', item.address || '');
          this.$set(this.data, 'sendMobile', item.mobile || '');
          this.$set(this.data, 'sendName', item.name || '');
          this.$set(this.data, 'sendPhone', item.phone || '');
          this.$set(this.data, 'receiveUnitAddress', item.company || '');
        }
      });
    },
    // 打开dialog时
    openDialog() {
      this.data.customCode = this.customCode || '';
      if (this.status === 'edit' && this.editIdData !== '') {
        let res = this.editIdData;
        this.$set(this.data, 'id', res.id || '');
        this.$set(this.data, 'mallRemark', res.mallRemark || res.remark || '');//商家订单号
        this.$set(this.data, 'receiveUnitAddress', res.receiveUnitAddress || '');//收件人单位
        this.$set(this.data, 'sendUnitAddress', res.sendUnitAddress || '');//发件人单位
        this.$set(this.data, 'fromCityCode', res.sendCityCode);
        this.$set(this.data, 'fromCityName', res.sendCity);
        this.$set(this.data, 'fromDistrictCode', res.sendAreaCode || res.sendCountyCode);
        this.$set(this.data, 'fromDistrictName', res.sendArea || res.sendCounty);
        this.$set(this.data, 'fromProvinceCode', res.sendProvinceCode);
        this.$set(this.data, 'fromProvinceName',  res.sendProvince);
        this.$set(this.data, 'toCityCode',  res.receiveCityCode);
        this.$set(this.data, 'toCityName',  res.receiveCity);
        this.$set(this.data, 'toDistrictCode',  res.receiveAreaCode || res.receiveCountyCode);
        this.$set(this.data, 'toDistrictName',  res.receiveArea  || res.receiveCounty);
        this.$set(this.data, 'toProvinceCode',  res.receiveProvinceCode);
        this.$set(this.data, 'toProvinceName',  res.receiveProvince);
        this.$set(this.data, 'sendAddress', res.sendAddress || '');
        this.$set(this.data, 'sendMobile', res.sendMobile || '');
        this.$set(this.data, 'sendName', res.sendName || '');
        this.$set(this.data, 'sendPhone', res.sendPhone || '');
        this.$set(this.data, 'receiveName', res.receiveName || '');
        this.$set(this.data, 'receiveMobile', res.receiveMobile || '');
        this.$set(this.data, 'receivePhone', res.receivePhone || '');
        this.$set(this.data, 'receiveAddress', res.receiveAddress || '');
        
        // 回显省市区组件
        this.$set(this.areaList, 'valueProvince', res.receiveProvinceCode);
        this.$set(this.areaList, 'nameProvince', res.receiveProvince);
        this.$set(this.areaList, 'valueCity', res.receiveCityCode);
        this.$set(this.areaList, 'nameCity', res.receiveCity);
        this.$set(this.areaList, 'valueDistrict', res.receiveAreaCode || res.receiveCountyCode);
        this.$set(this.areaList, 'nameDistrict', res.receiveArea || res.receiveCounty);
        let list = [];
        if (res.receiveProvinceCode){
          list.push(res.receiveProvinceCode);
        }
        if (res.receiveCityCode){
          list.push(res.receiveCityCode);
        }
        if (res.receiveAreaCode || res.receiveCountyCode){
          list.push(res.receiveAreaCode || res.receiveCountyCode);
        }
        this.$set(this.areaList, 'districtList', list);
        this.$set(this.areaListSend, 'valueProvince', res.sendProvinceCode);
        this.$set(this.areaListSend, 'nameProvince', res.sendProvince);
        this.$set(this.areaListSend, 'valueCity', res.sendCityCode);
        this.$set(this.areaListSend, 'nameCity', res.sendCity);
        this.$set(this.areaListSend, 'valueDistrict',  res.sendAreaCode || res.sendCountyCode);
        this.$set(this.areaListSend, 'nameDistrict', res.sendArea || res.sendCounty);
        let sendList = [];
        if (res.sendProvinceCode) {
          sendList.push(res.sendProvinceCode);
        }
        if (res.sendCityCode) {
          sendList.push(res.sendCityCode);
        }
        if (res.sendAreaCode || res.sendCountyCode) {
          sendList.push(res.sendAreaCode || res.sendCountyCode);
        }
        this.$set(this.areaListSend, 'districtList', sendList);
        this.$refs.areaList && this.$refs.areaList.getArea(JSON.stringify(this.areaList));
        this.$refs.areaListSend && this.$refs.areaListSend.getArea(JSON.stringify(this.areaListSend));
        if (res.receiveProvince == '海外') {
          this.isReciveHy = 'Y';
        }
        if (res.sendProvince == '海外') {
          this.isSendHy = 'Y';
        }
        let goodsData = res.goodLists || res.orderProducts || [];
        this.data.orderProducts = goodsData.map(o => {
          return {
            ...o,
            id: o.id || util.getUUID(8, 16),
            goodName: o.goodName,
            goodNum: o.goodNum,
            goodUrl: o.goodUrl
          }
        })

        // 时间初始货
        this.$set(this.data, 'timedPickup', res.timedPickup || (res.pickupOrderChannel == '2' ? '2' : '1'));

      } else {
        this.getAddressList();
        let obj = this.initProductInfo();
        // 先给第一个商品赋默认值
        this.data.orderProducts = [obj];
      }
    },
    resetRemarkForm() {
      this.$refs.remarkForm.resetFields();
    },
    submitRemarkFn() {
      this.$refs.remarkForm.validate((valid) => {
        if (valid) {
          if (this.remarkData.length >= 20) {
            this.$message.error('自定义备注最多20条。');
            return false;
          }
          // ('this.remarkForm', this.remarkForm);
          let params = [{ contents: this.remarkForm.remark.replace(/(^\s*)|(\s*$)/g, "") }];
          addCustomRemarkApi(params).then((res) => {
            if (res.message === 'ok') {
              this.resetRemarkForm();
              this.$message({
                message: '添加备注成功',
                type: 'success',
              });
              this.getRemarkList(); // 更新备注列表
            } else {
              this.$message.error('添加备注信息失败！');
            }
          });
        }
      });
    },
    // 清除发件人信息
    clearSenderInfo() {
      this.sendUploadedImage = '';
      this.totalInfoSend = '';
      this.$set(this.data, 'fromCityCode', '');
      this.$set(this.data, 'fromCityName', '');
      this.$set(this.data, 'fromDistrictCode', '');
      this.$set(this.data, 'fromDistrictName', '');
      this.$set(this.data, 'fromProvinceCode', '');
      this.$set(this.data, 'fromProvinceName', '');
      this.$set(this.data, 'sendAddress', '');
      this.$set(this.data, 'sendMobile', '');
      this.$set(this.data, 'sendName', '');
      this.$set(this.data, 'sendPhone', '');
      this.$set(this.data, 'sendUnitAddress', '');
      // 回显省市区组件
      this.$set(this.areaListSend, 'valueProvince', '');
      this.$set(this.areaListSend, 'nameProvince', '');
      this.$set(this.areaListSend, 'valueCity', '');
      this.$set(this.areaListSend, 'nameCity', '');
      this.$set(this.areaListSend, 'valueDistrict', '');
      this.$set(this.areaListSend, 'nameDistrict', '');
      this.$refs.areaListSend.clearArea();
      this.isSendHy = 'N';
      let valiArr = [
        'sendName',
        'sendMobile',
        'sendPhone',
        'districtSend',
        'sendAddress',
      ];
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate(valiArr);
      });
    },
    // 清空收件人信息
    clearReciverInfo() {
      this.totalInfo = '';
      this.reciveUploadedImage = '';
      this.$set(this.data, 'toCityCode', '');
      this.$set(this.data, 'toCityName', '');
      this.$set(this.data, 'toDistrictCode', '');
      this.$set(this.data, 'toDistrictName', '');
      this.$set(this.data, 'toProvinceCode', '');
      this.$set(this.data, 'toProvinceName', '');
      this.$set(this.data, 'receiveName', '');
      this.$set(this.data, 'receiveMobile', '');
      this.$set(this.data, 'receivePhone', '');
      this.$set(this.data, 'receiveAddress', '');
      this.$set(this.data, 'receiveUnitAddress', '');

      // 回显省市区组件
      this.$set(this.areaList, 'valueProvince', '');
      this.$set(this.areaList, 'nameProvince', '');
      this.$set(this.areaList, 'valueCity', '');
      this.$set(this.areaList, 'nameCity', '');
      this.$set(this.areaList, 'valueDistrict', '');
      this.$set(this.areaList, 'nameDistrict', '');
      
      this.$refs.areaList.clearArea();
      this.isReciveHy = 'N';
      let valiArr = [
        'receiveName',
        'receiveMobile',
        'receivePhone',
        'district',
        'receiveAddress',
      ];
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate(valiArr);
      });
    },
    // 获取备注列表
    getRemarkList() {
      this.remarkLoading = true;
      getCustomRemarkListApi().then((res) => {
        if (res.message === 'ok') {
          this.remarkLoading = false;
          this.remarkData = res.data;
        }
      }).finally(()=>{
        this.remarkLoading = false;
      });
    },
    // 显示添加备注提示框
    openRemarkDialog(){
      this.popoverRmark = true;
    },
    // 关闭添加备注提示框
    closeRemarkDialog() {
      this.popoverRmark = false;
      this.resetRemarkForm()
    },
    // 删除备注列表
    deleteRemark(row, index) {
      this.remarkData.splice(index,1);
      if(this.data.mallRemark == row.contents){
        this.data.mallRemark = '';
      }
      deleteCustomRemarkApi([row.id]).then((res) => {
        if (res.message === 'ok') {
          this.getRemarkList();
        }
      });
    },
    selectedGoodsOptions() {
      this.addOptionsDialogVisble = true;
    },
    closeGoodsOptions() {
      this.addOptionsDialogVisble = false;
      this.queryGoodsOptionsList();
    },
    // 图片识别发件人--上传图片
    beforeAvatarUploadSend(file) {
      if (!/^image\/(jpeg|png)$/.test(file.type)) {
        this.$alert('仅支持5M以内, jpg、jpeg、png格式的图片', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$alert('仅支持5M以内, jpg、jpeg、png格式的图片', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      var reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.imgUrl = data;
        this.identifyInfoType = 'send';
        this.isShowIndentifyPicDialog = true;
      };
      // 转化为base64
      reader.readAsDataURL(file);
      return false;
    },
    // 图片识别收件人--上传图片
    beforeAvatarUploadRecive(file) {
      if (!/^image\/(jpeg|png)$/.test(file.type)) {
        this.$alert('仅支持5M以内, jpg、jpeg、png格式的图片', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$alert('仅支持5M以内, jpg、jpeg、png格式的图片', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      var reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.imgUrl = data;
        this.identifyInfoType = 'receive'; 
        // console.log('this.imgUrl--recive', this.imgUrl);
        this.isShowIndentifyPicDialog = true;
      };
      // 转化为base64
      reader.readAsDataURL(file);
      return false;
    },
    // 关闭图片解析层
    closeIdentifyInfo() {
      this.isShowIndentifyPicDialog = false;
      this.identifyInfoType = '';
      this.imgUrl = '';
    },
    // 图片解析结果填充
    analysisPic(params) {
      let analysisStr = params.analysisStr;
      let type = params.type;
      if (type == 'send') {
        this.totalInfoSend = analysisStr;
        this.sendUploadedImage = params.uploadedImage;
      } else {
        this.totalInfo = analysisStr;
        this.reciveUploadedImage = params.uploadedImage;
      }
      this.smartResolve(type);
    },
    closePrivacyDialog(isChecked) {
      this.showPrivacyDialog = false; 
      if (isChecked) {
        this.isShowPrivacy = true;
      }
    },
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../../../styles/variables';
.systemSize {
  font-size: 12px;
  cursor: pointer;
}
/deep/ .el-form-item__label {
  font-weight: normal;
  font-size: 12px;
}
.nServiceStyleTitle {
  font-size: 12px;
  color: #999999;
  line-height: 16px;
}
#returnOrderInfo {
  background-color: #f0f2f8;
  font-size: 14px;
  .reutrn-box {
    padding: 10px 10px 20px 16px;
    background: #ffffff;
    margin-bottom: 10px;
    position: relative;
    .trangle {
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 12px 12px 0 0;
      border-color: #ECDFFF  transparent transparent transparent;
    }

    .icon-box {
      width: 84px;
      height: auto;
      margin-left: 6px;
      margin-right: 22px;
    }
    .icon-send-style {
      width: 56px;
      height: 56px;
      flex-shrink: 0;
      margin-bottom: 6px;
    }
    .icon-style{
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      margin-right: 5px;
    }
    .icon-box-small {
      margin-left: 5px;
      margin-right: 22px;
    }
    .y-mb-6 {
      margin-bottom: 6px;
    }
    .addBtn {
      height: 32px;
      border-radius: 2px;
    }
    .anlysize-style {
      height: 100%;
      width: 400px;
      display: flex;
      flex-direction: column;
      margin-left: 30px;
      border: 1px dashed $blue-import-border-style;
      .align-right {
        text-align: right;
        padding-right: 15px;
        padding-bottom: 3px;
        cursor: pointer;
      }
      .el-upload {
        display: block;
      }
    }
    .checked-box-service {
      display: inline-block;
      margin-right: 10px;
    }
    .recive-select-btn {
      display: inline-block;
      height: 32px;
      background: #F5F6F8;
      border-radius: 2px;
      padding: 4px;
      box-sizing: border-box;
      .radio-btn{
        display: inline-block;
        width: 76px;
        height: 24px;
        border-radius: 2px;
        font-size: 14px;
        color: #A2A5AC;
        line-height: 24px;
        font-weight: 600;
        text-align: center;
        cursor: pointer;
      }
      .active-radio-btn{
        color: $blue-style;
        background: #FFFFFF;
      }
      .y-mr-4 {
        margin-right: 4px;
      }
    }
    .y-mr-16 {
      margin-right: 16px;
    }
  }
  .invite-create-order {
    margin-bottom: 0;
    .close-invite {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }
  .anlysize-style /deep/ .el-textarea__inner {
    border: 0;
    height: 100%;
  }
  .clear-text {
    font-size: 12px;
    color: #a2a5ac;
    cursor: pointer;
  }

  .form-item-wrap-f {
    /deep/ .el-form-item__content {
      display: flex;
    }
  }
  .coustom-opt {
    cursor: pointer;
    padding-left: 10px;
    line-height: 24px;
  }
  .nAddRemarkStyle {
    box-sizing: border-box;
    padding-left: 5px;
    color: $blue-style;
    cursor: pointer;
  }
  .topForm-item{
    .el-form-item{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    /deep/ .el-form-item__label{
      text-align: left;
    }
    /deep/ .el-form-item__content{
      margin: 0!important;
    }
  }
  .y-w-500 {
    width: 390px;
  }
  .y-w-400 {
    width: 390px;
  }
  .y-ml-28 {
    margin-left: 28px;
  }
  .fixed-box {
    position: fixed;
    z-index: 2;
    bottom: 0px;
    width: calc(100% - 170px);
    height: 100px;
    box-sizing: border-box;
    font-size: 12px;
    background-color: $white;
    box-shadow: 0px -2px 17px 0px #DDE0EA;

    .top-box {
      .reward-tip {
        display: inline-block;
        background: linear-gradient( 270deg, rgba(255,77,79,0) 0%, #fbeef0 50%);
        font-weight: 500;
        font-size: 14px;
        color: #FF4D4F;
        line-height: 26px;
        margin-left: -10px;
        z-index: -1;
      }
    }
    
    /deep/ .el-button--small {
      height: 32px;
      font-size: 14px;
    }
  }
  
  .remote-style{
    /deep/ .el-input__icon:before {
      content: "\E6E1";
    }
  }
  .pb100{
    padding-bottom: 100px;
  }
  .pro-type-style {
    margin-top: 10px;
    width: 77px;
    height: 57px;
    // border: 1px solid rgba(233, 233, 233, 1);
    border-radius: 20px;
    .icon-tip {
      width: 100%;
      height: auto;
      display: inline-block;
    }
  }
  .a2a5ac {
    color: #a2a5ac!important;
  }
  .address-uploaded{
    position: relative;
    width: 430px;
    margin-left: 10px;
    padding: 0 10px;
    height: 120px;
    border: 1px solid #f5f5f5;
    img{
      width: 100%;
      height: 120px;
    }
    .viewClose {
      position: absolute;
      top: 0;
      right: 0;
      width: 18px;
      height: 18px;
      color: #999;
    }
  }
  .y-w-430 {
    width: 430px;
  }
}
.elli {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nselectRemark {
  cursor: pointer;
  font-size: 10px;
  line-height: 20px;
}
.hoverColor {
  color: #fe4b4b;
}
.selectRemarkSytle {
  background-color: $blue-style;
  color: #fff;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ninsuredServiceDialog {
  .title {
    width: 80%;
    margin: 0 auto;
    color: #000;
    margin-top: 20px;
    .icon_num1 {
      display: inline-block;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: $sidebar-bg-style;
      color: $blue-num-style;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      line-height: 32px;
      margin-right: 14px;
    }
  }
  table {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    line-height: 30px;
    margin-top: 10px;
    font-size: 12px;
    th {
      background-color: $blue-btn-bg-style;
      border-top: 1px solid #ebeef5;
    }
    .border-left {
      border-left: 1px solid #ebeef5;
    }
    .border-right {
      border-right: 1px solid #ebeef5;
    }
    td {
      border-top: 1px solid #ebeef5;
    }
    .colorRed {
      color: #fe4b4b;
    }
    .colDesp {
      color: #a2a5ac;
      text-align: left;
    }
  }
  .bgDesp {
    width: 80%;
    margin: 0 auto;
    margin-top: 10px;
    padding: 10px 15px;
    line-height: 22px;
    span {
      display: inline-block;
    }
    .line {
      width: 24px;
      color: #666666;
      text-align: center;
    }
    .content {
      width: calc(100% - 24px);
      vertical-align: top;
      font-size: 12px;
      color: #666666;
    }
  }
}
.right-text {
  right: 20px;
}
.y-mt-5 {
  margin-top: 5px;
}
.y-ml-5 {
  margin-left: 5px;
}
.y-mt-8 {
  margin-top: 8px;
}
.y-mb-8 {
  margin-bottom: 8px;
}
.y-ml-8 {
  margin-left: 8px;
}
.y-pb-8 {
  padding-bottom: 8px;
}
.y-b-l {
  border-bottom: 1px solid #DCDFE6;
}
.y-pb-16 {
  padding-bottom: 16px;
}
.y-w-1100 {
  width: 950px;
}
.y-ml-80 {
  margin-left: 80px;
}
.p40 {
  padding: 0 40px;
}
.y-ml-16 {
  margin-left: 16px;
}
.mt-34 {
  margin-top: 34px;
}
.pl44 {
  padding-left: 54px;
}
.order-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 2px;
}
.reward-icon {
  width: 44px;
  height: 44px;
  vertical-align: middle;
}
/deep/ .el-form-item--small.el-form-item.y-mb-0 {
  margin-bottom: 0;
}
/deep/ .el-radio {
  margin-right: 10px;
}

.radioIcon {
  cursor: pointer;
  margin-right: 10px;
  img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }  
}
.imgUrl {
  position: relative;
  .close-btn {
    position: absolute;
    right: -26px;
    top: 16px;
    z-index: 6;
    font-size: 16px;
    cursor: pointer;
    color: #999;
  }
}
.return-print-list_box {
  margin-bottom: 82px;
  padding-bottom: 1px;
}
.delLine {
  text-decoration: line-through;
  margin-right: 4px;
  margin-left: 4px;
}
.check-icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 10px;
}
.bottom--m-m{
  display: flex;
  align-items: center;
  justify-content: center;  
}
@media screen and (min-width: 1400px){
  .systemSize,
  .nServiceStyleTitle,
  /deep/ .el-form-item__label,
  .clear-text {
    font-size: 14px;
  }
}
</style>
